import { baseTr, baseEn, type BaseMessageKey } from "@csa/web-foundation";

// Turkish-first i18n (ADR 0015 §7). These are the ADMIN console's surface strings;
// the base chrome strings (auth, principal, four-eyes, generic errors) live in
// @csa/web-foundation and are merged in below. `app.title` overrides the base
// brand-neutral default with the admin console's product name.
export const tr = {
  "app.title": "CSA Privé — Yönetim Konsolu",
  "nav.catalog": "Sigortacı Kalite",

  // Üst-nav kabuğu (04) — logo yanı bölüm etiketi, dil ve rol
  "shell.section": "Yönetim",
  "shell.role.staff": "Yönetici",
  "shell.role.party": "Üye",
  "shell.role.service": "Servis",
  // Yönetişim işaretleri — kalıcı denetim şeridi ve danışman konsoluna dönüş
  "shell.audit": "Her görüntüleme ve değişiklik denetim kaydına işlenir · fresh-auth.",
  "shell.backToConsole": "Danışman Konsolu'na dön",
  // Sol-rail bölüm başlıkları (nav kümeleri; yalnızca sunum)
  "nav.section.overview": "Genel Bakış",
  "nav.section.catalog": "Katalog & Fiyat",
  "nav.section.relations": "Müşteri & Pazarlama",
  "nav.section.governance": "Uyum & Yönetişim",
  "nav.section.team": "Ekip",

  "catalog.heading": "Sigortacı Kalite Skoru",
  "catalog.pickCarrier": "Sigortacı seç",
  "catalog.selectPrompt": "Skoru düzenlemek için bir sigortacı seçin.",
  "catalog.loadingCarriers": "Sigortacılar yükleniyor…",
  "catalog.carriersError": "Sigortacılar yüklenemedi.",
  "catalog.noCarriers": "Sigortacı bulunamadı.",
  "catalog.type": "Tür",
  "catalog.status": "Durum",

  "quality.loading": "Skor yükleniyor…",
  "quality.coldStart": "Henüz skor yok — ilk skoru yazın (soğuk başlangıç).",
  "quality.latestHeading": "Güncel skor",
  "quality.source": "Kaynak",
  "quality.asOf": "Geçerlilik",
  "quality.appendOnlyNote":
    "Her kayıt yeni tarihli bir anlık görüntüdür; en güncel (as_of) kazanır — düzenleme değil, ekleme.",

  "metric.claimsPaymentSpeedDays": "Hasar Ödeme Süresi (gün)",
  "metric.claimsAcceptanceRatio": "Hasar Kabul Oranı",
  "metric.complaintRatio": "Şikayet Oranı",
  "metric.serviceScore": "Hizmet Skoru",
  "metric.solvencyRatio": "Solvency Oranı",
  "metric.networkStrength": "Anlaşmalı Ağ Gücü",
  "metric.claimsPaymentSpeedDays.help":
    "Sigortacının hasarı onayladıktan sonra ödemeyi kaç günde yaptığı (gün). Düşük = daha iyi.",
  "metric.claimsAcceptanceRatio.help":
    "Yapılan hasar başvurularının kabul edilme oranı (0–1, ör. 0,95). Yüksek = daha iyi.",
  "metric.complaintRatio.help":
    "Poliçe başına şikayet oranı (0–1, düşük değerler). Düşük = daha iyi.",
  "metric.serviceScore.help": "Genel hizmet/müşteri memnuniyeti skoru (0–100). Yüksek = daha iyi.",
  "metric.solvencyRatio.help":
    "Sigortacının mali yeterlilik (ödeme gücü) oranı (oran; genellikle 1'in üzerinde). Yüksek = daha güçlü.",
  "metric.networkStrength.help":
    "Anlaşmalı servis/hastane ağının genişliği skoru (0–100). Yüksek = daha iyi.",

  "form.heading": "CURATED skor yaz",
  "form.asOf": "Geçerlilik tarihi (opsiyonel)",
  "form.asOfHint": "Bu skorun geçerli olduğu tarih. Boş bırakırsan bugünün tarihi kullanılır.",
  "form.curate": "Skoru Yaz",
  "form.atLeastOne": "En az bir metrik girin.",
  "form.invalidMetric": "Negatif olmayan ondalık; en çok 8 tam, 4 ondalık basamak.",
  "form.invalidAsOf": "Geçersiz tarih — saat dilimi içeren ISO-8601 olmalı.",
  "form.readOnly": "Yalnızca okuma — skor yazma yetkiniz yok (catalog:write).",
  "form.success": "CURATED skor yazıldı.",

  // Catalog management — self-servis sigortacı + sürüm + branş yetkisi
  "nav.catalogMgmt": "Katalog",
  "cat.heading": "Katalog — Sigortacı Yönetimi",
  "cat.loading": "Sigortacılar yükleniyor…",
  "cat.empty": "Henüz sigortacı yok — aşağıdan ilk sigortacıyı ekleyin.",
  "cat.list.title": "Sigortacılar",
  "cat.carriersError": "Sigortacılar yüklenemedi.",
  "cat.detailEyebrow": "Sigortacı",
  "cat.appendOnlyTag": "Yalnızca ekleme",
  "cat.detail": "Detay",
  "cat.readOnly": "Yalnızca okuma — katalog yazma yetkiniz yok (catalog:write).",
  "cat.list.code": "Kod",
  "cat.list.tradeName": "Ticari unvan",
  "cat.list.type": "Tür",
  "cat.list.status": "Durum",
  "cat.type.CONVENTIONAL": "Konvansiyonel",
  "cat.type.KATILIM": "Katılım",
  "cat.status.ACTIVE": "Aktif",
  "cat.status.SUSPENDED": "Askıda",
  "cat.status.WITHDRAWN": "Ayrıldı",
  "cat.versions.heading": "Sürüm geçmişi",
  "cat.versions.loading": "Sürümler yükleniyor…",
  "cat.versions.empty": "Sürüm yok.",
  "cat.versions.version": "Sürüm",
  "cat.versions.legalName": "Yasal unvan",
  "cat.versions.window": "Geçerlilik penceresi",
  "cat.versions.current": "Güncel",
  "cat.versions.add": "Yeni sürüm ekle",
  "cat.versions.appendOnlyNote":
    "Sürümler eklenir (append-only): açık sürüm kapatılır, yeni sürüm açılır — mevcut sürüm düzenlenmez, geçmiş korunur.",
  "cat.versions.submit": "Sürüm ekle",
  "cat.versions.success": "Yeni sürüm eklendi.",
  "cat.auth.heading": "Branş yetkileri",
  "cat.linesLoadFailed": "Branş listesi okunamadı — form gönderilemiyor. Tekrar deneyin.",
  "comm.form.fromRequired": "Başlangıç tarihi zorunludur.",
  "cat.auth.loading": "Yetkiler yükleniyor…",
  "cat.auth.empty": "Tanımlı branş yetkisi yok.",
  "cat.auth.line": "Branş",
  "cat.auth.from": "Başlangıç",
  "cat.auth.to": "Bitiş (opsiyonel)",
  "cat.auth.open": "Açık",
  "cat.auth.add": "Branş yetkisi ver",
  "cat.auth.submit": "Yetki ver",
  "cat.auth.success": "Branş yetkisi kaydedildi.",
  "cat.auth.conflict": "Bu branş için zaten açık bir yetki var.",
  "cat.auth.invalidTo": "Geçersiz tarih — saat dilimi içeren ISO-8601 olmalı.",
  "cat.auth.toHint": "Opsiyonel; boş = süresiz (açık) yetki.",
  "cat.carrier.add": "Yeni sigortacı ekle",
  "cat.carrier.governedNote":
    "Yeni sigortacı, değişmez bir kimlik (kod) ve ilk sürümüyle oluşturulur. Sonraki değişiklikler yeni sürüm olarak eklenir (append-only); kayıt denetim iziyle (audit) tutulur.",
  "cat.carrier.codeHint": "Küçük harf-kebab (ör. allianz-sigorta); değişmez kimlik.",
  "cat.carrier.invalidCode": "Küçük harf-kebab olmalı: ör. allianz-sigorta.",
  "cat.carrier.submit": "Sigortacı ekle",
  "cat.carrier.success": "Sigortacı eklendi.",
  "cat.carrier.conflict": "Bu kod zaten kullanımda — farklı bir kod seçin.",

  // Katalog Yönetimi — bölüm sekmeleri (sigortacı · ürün · paket · kavram/teminat)
  "catmgmt.tabsLabel": "Katalog bölümleri",
  "catmgmt.tab.carriers": "Sigortacılar",
  "catmgmt.tab.products": "Ürünler",
  "catmgmt.tab.packages": "Paketler",
  "catmgmt.tab.concepts": "Kavram & Teminatlar",

  // Ürünler
  "prod.heading": "Katalog — Ürün Yönetimi",
  "prod.governedNote":
    "Ürün, değişmez bir kimlik (kod · sigortacı · branş) ve ilk sürümüyle oluşturulur. Sonraki değişiklikler yeni sürüm olarak eklenir (append-only); kayıt denetim iziyle tutulur.",
  "prod.list.title": "Ürünler",
  "prod.list.empty": "Katalogda henüz ürün yok.",
  "prod.list.loading": "Ürünler yükleniyor…",
  "prod.list.picked": "Seçili",
  "prod.lookup.title": "Ürünü koda göre getir",
  "prod.lookup.note":
    "Kodu biliyorsanız doğrudan getirin; bilmiyorsanız yukarıdaki listeden seçin.",
  "prod.lookup.submit": "Getir",
  "prod.loading": "Ürün yükleniyor…",
  "prod.notFound": "Bu kodla ürün bulunamadı.",
  "prod.detailEyebrow": "Ürün",
  "prod.current": "Güncel sürüm",
  "prod.salesStatus": "Satış durumu",
  "prod.targetSegment": "Hedef segment",
  "prod.sales.ACTIVE": "Satışta",
  "prod.sales.PAUSED": "Duraklatıldı",
  "prod.sales.DISCONTINUED": "Kaldırıldı",
  "prod.name": "Ürün adı",
  "prod.carrier": "Sigortacı",
  "prod.codeHint": "Küçük harf-kebab (ör. allianz-tamamlayici); değişmez kimlik.",
  "prod.version.add": "Yeni ürün sürümü ekle",
  "prod.version.submit": "Sürüm ekle",
  "prod.version.success": "Yeni ürün sürümü eklendi.",
  "prod.add": "Yeni ürün ekle",
  "prod.submit": "Ürün ekle",
  "prod.success": "Ürün eklendi.",

  // Paketler (teklif edilebilir birim; teminat seti sürümle birlikte donar)
  "pkg.heading": "Katalog — Paket Yönetimi",
  "pkg.governedNote":
    "Paket, teklif edilebilir birimdir; sürümü oluşturulurken teminat seti sabitlenir (pin) ve dondurulur. Kimlik (kod · ürün) değişmez; değişiklikler yeni sürüm olarak eklenir.",
  "pkg.list.title": "Dağıtılabilir paketler",
  "pkg.list.name": "Paket adı",
  "pkg.list.carrier": "Sigortacı",
  "pkg.pickLine": "Branş seç…",
  "pkg.pickLinePrompt": "Paketleri listelemek için bir branş seçin.",
  "pkg.loading": "Paketler yükleniyor…",
  "pkg.error": "Paketler yüklenemedi.",
  "pkg.empty": "Bu branş için dağıtılabilir paket yok.",
  "pkg.detailEyebrow": "Paket",
  "pkg.notFound": "Bu kodla paket bulunamadı.",
  "pkg.pinned.title": "Sabitlenmiş teminat seti",
  "pkg.pinned.frozenNote":
    "Bu set, sürüm oluşturulurken teminatların güncel sürümlerine sabitlenip donduruldu — değiştirmek yeni bir paket sürümü gerektirir.",
  "pkg.pinned.empty": "Sabitlenmiş teminat yok.",
  "pkg.pinned.role": "Rol",
  "pkg.pinned.pinnedVersion": "Sabitlenen sürüm",
  "pkg.pinned.limit": "Limit",
  "pkg.pinned.unlimited": "Limitsiz",
  "pkg.name": "Paket adı",
  "pkg.renewal": "Yenileme garantisi",
  "pkg.renewal.NONE": "Yok",
  "pkg.renewal.CONDITIONAL": "Koşullu",
  "pkg.renewal.LIFETIME": "Ömür boyu",
  "pkg.preexisting": "Mevcut rahatsızlık",
  "pkg.preexisting.NOT_APPLICABLE": "Uygulanmaz",
  "pkg.preexisting.EXCLUDED": "Kapsam dışı",
  "pkg.preexisting.COVERED_AFTER_WAITING": "Bekleme sonrası kapsamda",
  "pkg.preexisting.UNDERWRITTEN": "Değerlendirmeye tabi",
  "pkg.minEntryAge": "Min. giriş yaşı",
  "pkg.maxEntryAge": "Maks. giriş yaşı",
  "pkg.networkCode": "Ağ kodu",
  "pkg.networkHint": "Yalnızca ağ tabanlı branşlarda (ör. tss/oss) zorunlu.",
  "pkg.covset.title": "Teminat seti",
  "pkg.covset.pinTag": "Sabitlenir",
  "pkg.covset.note":
    "En az bir teminat. Her teminat, sunucuda güncel sürümüne çözülür ve sürümle birlikte dondurulur.",
  "pkg.covset.coverageCode": "Teminat kodu",
  "pkg.covset.role": "Rol",
  "pkg.covset.remove": "Kaldır",
  "pkg.covset.addRow": "Teminat ekle",
  "pkg.role.CORE": "Çekirdek",
  "pkg.role.RIDER": "Ek teminat",
  "pkg.role.OPTIONAL": "Opsiyonel",
  "pkg.version.add": "Yeni paket sürümü ekle",
  "pkg.version.note":
    "Sürümler eklenir (append-only): açık sürüm kapatılır, yeni sürüm taze bir teminat setiyle açılır — mevcut sürüm düzenlenmez.",
  "pkg.version.submit": "Sürüm ekle",
  "pkg.version.success": "Yeni paket sürümü eklendi.",
  "pkg.add": "Yeni paket ekle",
  "pkg.submit": "Paket ekle",
  "pkg.success": "Paket eklendi.",
  "pkg.codeHint": "Küçük harf-kebab; değişmez kimlik.",
  "pkg.productCode": "Ürün kodu",
  "pkg.productCodeHint": "Paketin bağlı olduğu ürünün kodu.",

  // Kavramlar (branş bazlı) & teminatlar
  "cpt.heading": "Katalog — Kavram & Teminat Yönetimi",
  "cpt.governedNote":
    "Kanonik kavramlar branş bazlıdır; teminatlar ise paketlere sabitlenen sigortacı teminat bloklarıdır. Kavram–teminat eşdeğerlik eşlemesi dört-göz onayına tabidir (aşağıya bakın).",
  "cpt.list.title": "Kanonik kavramlar",
  "cpt.pickLine": "Branş seç…",
  "cpt.pickLinePrompt": "Kavramları listelemek için bir branş seçin.",
  "cpt.loading": "Kavramlar yükleniyor…",
  "cpt.error": "Kavramlar yüklenemedi.",
  "cpt.empty": "Bu branşta tanımlı kavram yok.",
  "cpt.name": "Ad",
  "cpt.definition": "Tanım",
  "cpt.add": "Yeni kavram ekle",
  "cpt.submit": "Kavram ekle",
  "cpt.success": "Kavram eklendi.",
  "cpt.equiv.title": "Eşdeğerlik eşlemesi",
  "cpt.equiv.fourEyesTag": "Dört-göz",
  "cpt.equiv.flag":
    "Teminat–kavram eşdeğerlik eşlemesi ve onayı dört-göz yönetişimine tabidir (POST /equivalences, @RequireFourEyes). Bu yönetilen öneri/onay akışı bu sürümde eklenmedi — ayrı bir iş olarak işaretlendi.",

  // Teminatlar (create dört-göz DEĞİL; yalnızca eşdeğerlik dört-göz)
  "cov.lookup.title": "Teminatı koda göre getir",
  "cov.lookup.note":
    "Teminat listesi uç noktası yok — teminat, değişmez koduyla getirilir (GET /coverages/:code).",
  "cov.loading": "Teminat yükleniyor…",
  "cov.notFound": "Bu kodla teminat bulunamadı.",
  "cov.detailEyebrow": "Teminat",
  "cov.name": "Teminat adı",
  "cov.limit": "Limit",
  "cov.unlimited": "Limitsiz",
  "cov.subLimits": "Alt limitler",
  "cov.limitAmount": "Limit tutarı",
  "cov.deductibleAmount": "Muafiyet tutarı",
  "cov.coPayPercent": "Katılım payı (%)",
  "cov.geographicScope": "Coğrafi kapsam",
  "cov.limitUnlimited": "Limitsiz",
  "cov.moneyHint": "Ondalık dize; 2 basamağa kadar (ör. 100000.00).",
  "cov.percentHint": "Yüzde, ondalık dize (ör. 20 veya 20.00).",
  "cov.invalidMoney": "Geçersiz tutar — negatif olmayan ondalık, en çok 2 basamak.",
  "cov.invalidPercent": "Geçersiz yüzde — ondalık dize olmalı.",
  "cov.add": "Yeni teminat ekle",
  "cov.submit": "Teminat ekle",
  "cov.success": "Teminat eklendi.",
  "cov.governedNote":
    "Teminat, değişmez bir kimlik (kod · sigortacı · branş) ve ilk sürümüyle oluşturulur; değişiklikler yeni sürüm olarak eklenir. Teminat oluşturma dört-göz DEĞİLdir (yalnızca eşdeğerlik eşlemesi dört-gözdür).",

  // AL2b — Commission rates
  "nav.commissionRates": "Komisyon",
  "comm.heading": "Komisyon Oranları",
  "comm.subheading":
    "Sigortacı·branş·ürün oranları — sakin, tarih-etkin ve yalnızca ekleme (değiştir = kapat + yeni dönem).",
  "comm.list.title": "Mevcut ve geçmiş oranlar",
  "comm.appendOnlyTag": "Yalnızca ekleme",
  "comm.filter.carrier": "Sigortacıya göre",
  "comm.filter.line": "Branşa göre",
  "comm.filter.all": "Tümü",
  "comm.loading": "Oranlar yükleniyor…",
  "comm.error": "Oranlar yüklenemedi.",
  "comm.coldStart": "Henüz oran tanımlı değil.",
  "comm.list.carrier": "Sigortacı",
  "comm.list.line": "Branş",
  "comm.list.product": "Ürün",
  "comm.list.rate": "Oran",
  "comm.list.from": "Başlangıç",
  "comm.list.to": "Bitiş / Durum",
  "comm.allProducts": "tüm ürünler",
  "comm.current": "Güncel",
  "comm.history": "geçmiş",
  "comm.form.heading": "Yeni oran ekle",
  "comm.form.appendOnlyNote":
    "Oranlar eklenir (yeni tarihli kayıt); mevcut açık bir oran düzenlenmez — güncelleme yönetilen yolu gerektirir.",
  "comm.form.carrier": "Sigortacı",
  "comm.form.line": "Branş",
  "comm.form.product": "Ürün (opsiyonel)",
  "comm.form.productHint": "Boş = tüm branş (ürün bazlı oran için ürün kimliği)",
  "comm.form.rate": "Oran (%)",
  "comm.form.invalidRate": "Yüzde (0,100] arası, en çok 2 ondalık — yuvarlanmaz.",
  "comm.form.effectiveFrom": "Başlangıç (ISO-8601 + saat dilimi)",
  "comm.form.invalidFrom": "Geçersiz tarih — saat dilimi içeren ISO-8601 olmalı.",
  "comm.form.effectiveTo": "Bitiş (opsiyonel, başlangıçtan sonra)",
  "comm.form.effectiveToHint": "Opsiyonel; başlangıçtan sonra olmalı.",
  "comm.form.invalidTo": "Bitiş başlangıçtan sonra, saat dilimli ISO-8601 olmalı.",
  "comm.form.save": "Oranı Kaydet",
  "comm.form.readOnly": "Yalnızca okuma — oran yazma yetkiniz yok (commission:write).",
  "comm.form.success": "Oran kaydedildi.",
  "comm.form.conflict":
    'Bu kapsam için geçerli bir oran var. Değiştirmek için listedeki güncel oranda "Oranı değiştir"i kullanın.',
  "comm.list.actions": "İşlem",
  "comm.change.action": "Oranı değiştir",
  "comm.change.heading": "Oranı değiştir (kapat + yeni dönem)",
  "comm.change.note":
    "Mevcut oran kapatılır ve yeni tarihli bir oran açılır — üzerine yazılmaz, geçmiş korunur.",
  "comm.change.newRate": "Yeni oran (%)",
  "comm.change.effectiveFrom": "Geçerlilik başlangıcı (opsiyonel)",
  "comm.change.effectiveFromHint": "Boş = şimdi; mevcut oranın başlangıcından sonra olmalı.",
  "comm.change.submit": "Değişikliği kaydet",
  "comm.change.cancel": "Vazgeç",
  "comm.change.success": "Oran değiştirildi — önceki kapandı, yenisi açıldı.",

  // AL3 — Score-Registry config governance
  "nav.config": "Yapılandırma",
  // Pazarlama konsolu (MK-FE)
  "mk.heading": "Pazarlama",
  "mk.subtitle":
    "Yönetişimli iletişim — blast aracı değil. Her gönderim server-side kapılardan geçer.",
  // #291 — CR-1b kayıtlı segment yazma yüzeyi (segment:write@all). Yönetişimli
  // primitive kompozisyonu; sunucu allow-list'i sahiplenir, geçersiz param 400.
  "seg.title": "Kayıtlı segmentler",
  "seg.sub":
    "Yönetişimli primitiflerden bileşik segmentler; danışman defterine göre çalışır. Komisyon hiçbir yerde yok.",
  "seg.loading": "Yükleniyor…",
  "seg.loadError": "Segmentler yüklenemedi",
  "seg.loadErrorDesc": "Liste okunamadı; tekrar deneyin.",
  "seg.empty": "Henüz kayıtlı segment yok",
  "seg.emptyDesc": "Aşağıdan yönetişimli primitiflerle ilk segmenti oluşturun.",
  "seg.ruleCount": "{n} kural",
  "seg.match.ALL": "Tüm kurallar (VE)",
  "seg.match.ANY": "Herhangi biri (VEYA)",
  "seg.status.ACTIVE": "Aktif",
  "seg.status.ARCHIVED": "Arşivli",
  "seg.archive": "Arşivle",
  "seg.updateError": "Segment güncellenemedi.",
  "seg.new": "Yeni segment",
  "seg.newSub": "İsim + eşleşme modu + en az bir kural. Parametreler sunucuda doğrulanır.",
  "seg.name": "Segment adı",
  "seg.namePlaceholder": "Örn. 30 günde yenilenecekler",
  "seg.matchLabel": "Eşleşme modu",
  "seg.rules": "Kurallar",
  "seg.noRules": "Henüz kural yok — aşağıdan ekleyin.",
  "seg.primitive": "Primitif",
  "seg.addRule": "Kural ekle",
  "seg.removeRule": "Kaldır",
  "seg.create": "Segmenti oluştur",
  "seg.createError": "Segment oluşturulamadı — parametreleri kontrol edin.",
  "mk.iys.title": "İYS durumu",
  "mk.iys.registration": "Kayıt",
  "mk.iys.registrationValue": "Kayıtlı değil",
  "mk.iys.send": "Gönderim",
  "mk.iys.sendValue": "Pilot · kapalı",
  "mk.iys.residency": "Veri konumu",
  "mk.iys.residencyValue": "TR · WhatsApp egress-gate'li",
  "mk.sendDeferred":
    "Gönderim ertelendi (yerleşim + İYS bekleniyor). Bu konsol hiçbir mesaj göndermez; yalnızca değerlendirir.",
  "mk.loading": "Yükleniyor…",
  "mk.error.title": "Bir şey ters gitti",
  "mk.error.detail": "Veri alınamadı.",
  "mk.readOnly":
    "Bu yüzeyi görüntüleme yetkiniz var; kampanya tanımlamak için marketing:manage gerekir.",
  "mk.error.noPermission": "Bu işlem için yetkiniz yok.",
  "mk.error.unavailable": "Servis şu an kullanılamıyor; birazdan tekrar deneyin.",
  "mk.error.validation": "Girdiler geçersiz; alanları kontrol edin.",
  "mk.trigger.title": "Yaşam döngüsü tetikleyicileri",
  "mk.trigger.intro":
    "Her tetikleyici bir kohortu aynı no-spam eşiklerinden geçirir — gönderim yok, sadece tanımlama.",
  "mk.trigger.renewalDue": "Yenileme yaklaşıyor (≤30 gün)",
  "mk.trigger.coverageGap": "Teminat açığı (sigortasız araç)",
  "mk.trigger.households": "hane",
  "mk.audience.title": "Ulaşılabilirlik defteri",
  "mk.audience.gate": "Bastırma eşikleri (touch-cap)",
  "mk.audience.channel": "Kanal",
  "mk.audience.reachable": "Ulaşılabilir",
  "mk.audience.noConsent": "Rıza yok",
  "mk.audience.careHold": "Care-hold",
  "mk.audience.coolOff": "Cool-off",
  "mk.audience.touchCap": "Touch-cap",
  "mk.audience.book": "Defter",
  "mk.attr.title": "Kaynak → dönüşüm",
  "mk.attr.leads": "Lead",
  "mk.attr.conversions": "Dönüşüm",
  "mk.attr.source": "Kaynak",
  "mk.attr.rate": "Oran",
  "mk.attr.cac": "CAC",
  "mk.attr.external": "Dış besleme",
  "mk.campaign.title": "Kampanyalar",
  "mk.campaign.name": "Ad",
  "mk.campaign.channel": "Kanal",
  "mk.campaign.segment": "Segment",
  "mk.campaign.create": "Oluştur",
  "mk.campaign.statusCol": "Durum",
  "mk.campaign.action": "İşlem",
  "mk.campaign.resolve": "Çöz",
  "mk.campaign.activate": "Aktifleştir",
  "mk.campaign.close": "Kampanyayı kapat",
  "mk.campaign.empty.title": "Kampanya yok",
  "mk.campaign.empty.desc": "Rıza-sınırlı bir kampanya tanımlayın; gönderim yapılmaz.",
  "mk.campaign.status.draft": "Taslak",
  "mk.campaign.status.active": "Aktif",
  "mk.campaign.status.closed": "Kapalı",
  "mk.campaign.eligible": "uygun",
  "mk.campaign.suppressed": "bastırıldı",
  "cfg.heading": "Yapılandırma Yönetimi (Skor Kütüğü)",
  "cfg.subheading":
    "Yönetişimli değişiklik yolu: öner → (dört-göz) ikinci kişi onayı → etkinleştir. Sürümler yalnızca eklenir.",
  "cfg.registryTitle": "Skor kütüğü ad alanları",
  "cfg.governNote":
    "Yönetişim sunucuda uygulanır; öneren ≠ onaylayan (dört-göz), sürümler eklenir.",
  "cfg.appendOnlyTag": "Yalnızca ekleme",
  "cfg.appendOnlyNote":
    "Her sürüm yeni ve değişmezdir; etkin sürüm değişir, geçmiş silinmez — düzenleme değil, ekleme.",
  "cfg.loading": "Yükleniyor…",
  "cfg.namespace": "Ad alanı",
  "cfg.governance": "Yönetişim",
  "cfg.active": "Etkin sürüm",
  "cfg.noActive": "Etkin sürüm yok",
  // Skor kütüğü ad alanları — Türkçe başlık + ne işe yaradığı. Kod (PRIORITY vb.)
  // teknik kimlik olarak altında küçük mono ile korunur.
  "cfg.ns.PRIORITY.title": "Öncelik puanı",
  "cfg.ns.PRIORITY.desc":
    "Günlük kuyruktaki işlerin hangi sırayla öne çıkacağını belirleyen ağırlıklar.",
  "cfg.ns.RENEWAL_CADENCE.title": "Yenileme ritmi",
  "cfg.ns.RENEWAL_CADENCE.desc":
    "Poliçe vadesi yaklaşırken müşteriye kaç gün önce ve hangi aralıklarla dokunulacağı.",
  "cfg.ns.GAP_RULES.title": "Eksik teminat kuralları",
  "cfg.ns.GAP_RULES.desc":
    "Hanede hangi teminat boşluklarının fırsat olarak işaretleneceğini tanımlar.",
  "cfg.ns.SUPPRESSION_GATES.title": "Bastırma kapıları",
  "cfg.ns.SUPPRESSION_GATES.desc":
    "Bir dokunuşun engellenme sırası: özen-bekletme → rıza → soğuma → temas sınırı.",
  "cfg.ns.LAWFUL_BASIS_MAP.title": "Hukuki sebep eşlemesi",
  "cfg.ns.LAWFUL_BASIS_MAP.desc":
    "Her işlem türünün KVKK hukuki sebebine (rıza / sözleşme / meşru menfaat) bağlanması.",
  "cfg.ns.RECONCILIATION.title": "Mutabakat eşikleri",
  "cfg.ns.RECONCILIATION.desc":
    "Komisyon ekstresi ile beklenen tutarın ne kadar sapmada 'fark' sayılacağı.",
  "cfg.ns.CARRIER_QUALITY.title": "Sigortacı kalite ağırlıkları",
  "cfg.ns.CARRIER_QUALITY.desc":
    "Sigortacı kalite skorunu oluşturan bileşenlerin ağırlıkları (komisyon sıralamaya girmez).",
  "cfg.manage": "Yönet",
  "cfg.version": "Sürüm",
  "cfg.history": "Sürüm geçmişi",
  "cfg.badge.fourEyes": "Dört göz (iki kişi)",
  "cfg.badge.normal": "Normal yönetim",
  "cfg.status.DRAFT": "Taslak",
  "cfg.status.PENDING_APPROVAL": "Onay bekliyor",
  "cfg.status.ACTIVE": "Etkin",
  "cfg.status.SUPERSEDED": "Geçersiz kılındı",
  "cfg.status.REJECTED": "Reddedildi",
  "cfg.propose.heading": "Yeni sürüm öner",
  "cfg.propose.readOnly": "Yalnızca okuma — öneri yetkiniz yok (config:propose).",
  "cfg.propose.payload": "Değer (JSON)",
  "cfg.propose.payloadHint":
    "Bu namespace için yeni yapılandırma değeri (JSON). Değişiklik onaya gider (four-eyes).",
  "cfg.propose.changeReason": "Değişiklik gerekçesi (opsiyonel)",
  "cfg.propose.changeReasonHint":
    "Bu değişikliği neden yaptığını kısaca yaz — denetim kaydına (audit) geçer.",
  "cfg.propose.submit": "Öner",
  "cfg.propose.invalidJson": "Geçersiz JSON — değer bir nesne olmalı.",
  "cfg.propose.success": "Sürüm önerildi.",
  "cfg.requestApproval": "Onay iste",
  "cfg.awaitingApprover": "İkinci yetkili onayı bekleniyor",
  "cfg.activate": "Etkinleştir",
  "cfg.reject": "Reddet",
  "cfg.rejectReason": "Reddetme gerekçesi:",
  "cfg.timeTravel.heading": "Geçmişe bak (belirli an)",
  "cfg.timeTravel.at": "Tarih",
  "cfg.timeTravel.go": "Getir",
  "df.today": "Bugün",
  "df.now": "Şimdi",
  "cfg.inbox.heading": "Onay Kutusu",
  "cfg.inbox.subtitle": "Onayınızı bekleyen istekler (ikinci yetkili)",
  "cfg.inbox.fourEyesNote":
    "Öneren kendi isteğini onaylayamaz — sunucu, bekleyen listenizden kendi isteklerinizi çıkarır.",
  "cfg.inbox.loading": "Yükleniyor…",
  "cfg.inbox.none": "Bekleyen onay yok.",
  "cfg.inbox.loadFailed": "Onay kutusu okunamadı. Bekleyen onay OLMADIĞI anlamına gelmez.",
  "prod.list.loadFailed": "Ürün listesi okunamadı. Katalog BOŞ anlamına gelmez.",
  "pan.exportFailed": "Dışa aktarma başarısız. Dosya oluşturulmadı.",
  "mk.segmentsLoadFailed":
    "Segment listesi okunamadı, bu yüzden kampanya oluşturulamıyor. Segment OLMADIĞI anlamına gelmez.",
  "sc.historyLoadFailed": "Puan geçmişi okunamadı. Hiç puanlanmadığı anlamına gelmez.",
  "cfg.inbox.rejectConfirm": "Reddi onayla",
  "cfg.inbox.actionFailed": "Onay işlemi kaydedilemedi. Karar alınmadı.",
  "cfg.rejectFailed": "Sürüm reddedilemedi. Sürüm durumu değişmedi.",
  "cfg.activateFailed": "Sürüm etkinleştirilemedi. Aktif sürüm değişmedi.",
  "cfg.requestFailed": "Onay talebi açılamadı.",
  "common.offline": "Bağlantı kurulamadı. İşlem sunucuya ulaşmadı.",
  "cfg.inbox.resource": "Kaynak",
  "cfg.inbox.requester": "İsteyen",
  "cfg.inbox.approve": "Onayla",
  "cfg.inbox.reject": "Reddet",
  "cfg.inbox.review": "İncele",
  "cfg.inbox.noReview": "Bu işlem için inceleme ekranı yok",
  "cfg.inbox.rejectReason": "Reddetme gerekçesi:",

  // U10-REPORTS-F — Yönetim pilot skor panosu (6 metrik read'i tüketir)
  "nav.reports": "Raporlar",
  "nav.marketing": "Pazarlama",
  "rep.heading": "Pilot Skor Panosu",
  "rep.subheading":
    "Müşteri #1 pilotunun kanıt döngüsü — altı toplu read (sunucu tarafı toplama; tarayıcıda hesaplama yok).",
  "rep.cohortFrom": "Kohort başlangıç (onboard)",
  "rep.cohortTo": "Kohort bitiş (onboard)",
  "rep.windowFrom": "Pencere başlangıç",
  "rep.windowTo": "Pencere bitiş",
  "rep.cohortHint": "Pilot kohortu — hane/lead'in onboard tarihi aralığı. Boş = sınırsız.",
  "rep.windowHint":
    "Ölçüm penceresi — olayın (issuance, renewal, komisyon) tarih aralığı. Boş = sınırsız.",
  "rep.loading": "Metrik yükleniyor…",
  "rep.error": "Metrik yüklenemedi.",
  "rep.emptyRows": "Bu kohort/pencere için satır yok (gerçek sıfır).",
  "rep.rate": "Oran",
  "rep.total": "Toplam",
  "rep.mean": "Ortalama",
  "rep.median": "Medyan",
  "rep.min": "En az",
  "rep.max": "En çok",
  "rep.yes": "Evet",
  "rep.no": "Hayır",
  "rep.externalPending": "Dış besleme bekleniyor",
  "rep.periodAll": "Tüm zamanlar",
  "rep.cohortChip": "Kohort",
  "rep.windowChip": "Pencere",
  "rep.kpi.conversion": "Kaynak dönüşümü",
  "rep.kpi.conversionNote": "toplam lead → poliçe",
  "rep.kpi.motorHealth": "Motor → sağlık",
  "rep.kpi.motorHealthNote": "çapraz satış",
  "rep.kpi.retention": "Retention",
  "rep.kpi.retentionNote": "yenileme oranı",
  "rep.kpi.priceIntegrity": "Fiyat bütünlüğü",
  "rep.kpi.priceIntegrityNote": "eşleşme oranı",

  "rep.r1.title": "1 — Kaynağa göre dönüşüm",
  "rep.r1.desc":
    "Kohort lead'leri (lead.source) → düzenlenen poliçe + oran. Yalnızca pay (numerator).",
  "rep.r1.cacPending":
    "CAC paydası (kanal harcaması) dış Finans beslemesidir (gap A) — bu read'de birleştirilmez, uydurulmaz.",
  "rep.r1.source": "Kaynak",
  "rep.r1.leads": "Lead",
  "rep.r1.conversions": "Dönüşüm",

  "rep.r2.title": "2 — Motor → sağlık dönüşümü",
  "rep.r2.desc": "Motor hane (payda) → sonradan sağlık poliçesi alan (pay), oran, medyan gün.",
  "rep.r2.converted": "dönüşen",
  "rep.r2.motorHh": "motor hane",
  "rep.r2.medianDays": "Medyan dönüşüm günü",
  "rep.r2.sameDayAttach": "Aynı gün attach (hariç)",
  "rep.r2.crossSellIntent": "CROSS_SELL niyetli hane",

  "rep.r3.title": "3 & 5 — Hane derinliği",
  "rep.r3.attach": "Çok-canlı attach (sağlık hane başına can)",
  "rep.r3.healthHh": "Sağlık hane",
  "rep.r3.depth": "Hane derinliği (hane başına poliçe)",
  "rep.r3.households": "Hane",

  "rep.r4.title": "4 — Retention / yenileme",
  "rep.r4.desc": "Yenileme-uygun (payda) → yenilenen / lapse, retention oranı.",
  "rep.r4.renewed": "yenilenen",
  "rep.r4.eligible": "uygun",
  "rep.r4.lapsed": "lapse",

  "rep.r5.title": "6 — Danışman birim ekonomisi",
  "rep.r5.desc":
    "Danışman başına komisyon (alınan/beklenen), hane, poliçe, hane başına gelir. Yalnızca gelir tarafı.",
  "rep.r5.costPending":
    "Danışman maliyeti dış Finans beslemesidir (gap A) — bu read'de birleştirilmez, uydurulmaz.",
  "rep.r5.advisor": "Danışman",
  "rep.r5.households": "Hane",
  "rep.r5.policies": "Poliçe",
  "rep.r5.received": "Alınan komisyon",
  "rep.r5.expected": "Beklenen komisyon",
  "rep.r5.revPerHh": "Hane başına gelir",

  "rep.r6.title": "7 — Premium deneyim paneli",
  "rep.r6.priceIntegrity": "Fiyat bütünlüğü",
  "rep.r6.matched": "eşleşen",
  "rep.r6.checked": "kontrol edilen",
  "rep.r6.issuanceSpeed": "Düzenleme hızı",
  "rep.r6.issued": "Düzenlenen",
  "rep.r6.medianHours": "Medyan saat",
  "rep.r6.p90Hours": "p90 saat",
  "rep.r6.maxHours": "En çok saat",
  "rep.r6.noSpam": "Spam yok (touch-cap)",
  "rep.r6.households": "Hane",
  "rep.r6.maxTouches": "En çok temas",
  "rep.r6.meanTouches": "Ortalama temas",
  "rep.r6.breaches": "İhlal",
  "rep.r6.touchCap": "Touch-cap (config)",
  "rep.r6.noConfig": "Etkin config yok",
  "rep.r6.claimsAdvocacy": "Hasar savunuculuğu",
  "rep.r6.paid": "ödenen",
  "rep.r6.resolved": "sonuçlanan",
  "rep.r6.claims": "Hasar",
  "rep.r6.firstResponse": "İlk yanıt (medyan saat)",
  "rep.r6.resolution": "Çözüm (medyan gün)",
  "rep.r6.satisfaction": "Memnuniyet (1–5)",
  "rep.r6.namedAdvisor": "Adlı danışman",
  "rep.r6.singleOwner": "Tek-sahip bütünlüğü",
  "rep.r6.reassignments": "Yeniden atama",

  // Danışman hizmet-kalitesi panosu (per-advisor service quality — /advisor-performance)
  "rep.ap.heading": "Danışman hizmet kalitesi",
  "rep.ap.subheading":
    "Danışman başına hizmet kalitesi — isme göre sıralı, sıralama (ranking) yok, komisyon yok. Gerçekleşen + mevcut durum; öngörü yok. Her figür kaynağında denetlenebilir.",
  "rep.ap.asOf": "Şu ana kadar",
  "rep.ap.empty": "Bu kapsam için danışman yok (gerçek boş — uydurma sayı değil).",
  "rep.ap.sla": "SLA uyumu",
  "rep.ap.onTime": "zamanında",
  "rep.ap.open": "Açık",
  "rep.ap.atRisk": "Riskli",
  "rep.ap.breached": "İhlal",
  "rep.ap.retention": "Yenileme tutundurma",
  "rep.ap.conversion": "Teklif → kabul",
  "rep.ap.offersSent": "Gönderilen teklif",
  "rep.ap.accepted": "kabul edilen",
  "rep.ap.claims": "Hasar savunuculuğu",
  "rep.ap.claimsCount": "Hasar",
  "rep.ap.resolved": "Sonuçlanan",
  "rep.ap.resolutionDays": "Çözüm (medyan gün)",
  "rep.ap.satisfaction": "Memnuniyet (1–5)",
  "rep.ap.paid": "ödenen",
  "rep.ap.depth": "Hane derinliği",
  "rep.ap.noSpam": "Spam yok disiplini",
  "rep.ap.suppressed": "Bastırılan öğe",
  "rep.ap.capBreaches": "Touch-cap ihlali",
  "rep.ap.careHold": "Care-hold yönetimi",
  "rep.ap.careHoldHh": "Care-hold hane",

  // 04 — Yönetim Paneli (dashboard / home)
  "nav.dashboard": "Panel",
  "dash.heading": "Yönetim Paneli",
  "dash.period": "Bu ay",
  "dash.greetingPre": "Merhaba —",
  "dash.greetingApprovals": "governed onay",
  "dash.greetingPost": "sizi bekliyor.",
  "dash.greetingNone": "bekleyen governed onay yok.",
  "dash.restricted": "Bu panonun bazı bölümleri için yetkiniz yok.",
  "dash.backendFirst": "Backend bekliyor",
  // KPI kartları
  "dash.kpi.activePolicies": "Aktif poliçe",
  "dash.kpi.newLeads": "Bu ay yeni lead",
  "dash.kpi.pendingApprovals": "Bekleyen onaylar",
  "dash.kpi.claimResolution": "Hasar çözüm süresi (medyan gün)",
  "dash.badge.fourEyes": "Dört-göz",
  "dash.kpi.noComposite": "Bu KPI için toplu read yok — backend-first (uydurulmadı).",
  "dash.kpi.leadWindow": "Bu ay onboard olan lead (conversion-by-source · gerçek read).",
  "dash.kpi.pendingReal": "Onay kutunuzdaki (awaiting-me) governed onaylar · gerçek read.",
  "dash.kpi.claimReal": "premium-experience · hasar çözüm medyanı (gün) · gerçek read.",
  // Sigortacı kalite tablosu
  "dash.carriers.title": "Sigortacı kalite karnesi",
  "dash.carriers.manageAll": "Tümünü yönet →",
  "dash.carriers.colCarrier": "Sigortacı",
  "dash.carriers.colScore": "Kalite skoru",
  "dash.carriers.colTrend": "Trend",
  "dash.carriers.colType": "Tür",
  "dash.carriers.colStatus": "Durum",
  "dash.carriers.loading": "Sigortacılar yükleniyor…",
  "dash.carriers.error": "Sigortacılar yüklenemedi.",
  "dash.carriers.empty": "Sigortacı bulunamadı.",
  "dash.carriers.scorePending":
    "Toplu kalite skoru / trend backend-first: skor governed sunucu-tarafı hesaplamadır, listede read yok, tarayıcıda hesaplanmaz.",
  // 6-ay lead grafiği
  "dash.chart.title": "Son 6 ay · yeni lead",
  "dash.chart.backendFirst": "Aylık zaman serisi read'i yok — backend-first. Sahte eğri çizilmedi.",
  // Denetim / governed onay
  "dash.audit.title": "Denetim günlüğü",
  "dash.audit.seeAll": "Onay kutusu →",
  "dash.audit.backendFirst":
    "Geçmişe dönük denetim günlüğü read'i (GET) yok — backend-first. Aşağıda gerçek bekleyen governed onaylar (awaiting-me) gösterilir.",
  "dash.audit.pendingTitle": "Bekleyen governed onaylar",
  "dash.audit.colAction": "Eylem",
  "dash.audit.colRequester": "İsteyen",
  "dash.audit.colStatus": "Durum",
  "dash.audit.statusPending": "Onay bekliyor",
  "dash.audit.loading": "Yükleniyor…",
  "dash.audit.empty": "Bekleyen governed onay yok.",

  // Platform Panel (#204) — /v1/metrics/admin-platform composed read; 6 bölüm, honest-empty
  "pan.subtitle": "Platform sağlığı, curation ve uyum — tek bakışta.",
  "pan.export": "CSV indir",
  "pan.asOf": "Güncel",
  "pan.cohort": "Kohort",
  "pan.window": "Pencere",
  "pan.periodAll": "Tüm zamanlar",
  "pan.loading": "Panel yükleniyor…",
  "pan.error": "Panel verileri yüklenemedi.",
  // (1) Curation kapsamı
  "pan.cur.title": "Curation kapsamı",
  "pan.cur.curated": "Curated",
  "pan.cur.total": "Toplam",
  "pan.cur.coldStart": "Soğuk başlangıç",
  "pan.cur.empty": "Henüz panelde sigortacı yok.",
  "pan.cur.note": "CURATED skorlu sigortacı oranı; kalanı soğuk-başlangıç tohumuyla çalışır.",
  // (2) Config governance
  "pan.cfg.title": "Config governance",
  "pan.cfg.pending": "Bekleyen dört-göz onayı",
  "pan.cfg.active": "Namespace başına aktif sürüm",
  "pan.cfg.guardrail": "guardrail",
  "pan.cfg.activeEmpty": "Henüz aktif sürüm yok.",
  "pan.cfg.recent": "Son config değişiklikleri",
  "pan.cfg.colNamespace": "Namespace",
  "pan.cfg.colVersion": "Sürüm",
  "pan.cfg.colStatus": "Durum",
  "pan.cfg.colGovernance": "Yönetişim",
  "pan.cfg.colReason": "Gerekçe",
  "pan.cfg.colAsOf": "Geçerlilik",
  "pan.cfg.empty": "Kayıtlı config değişikliği yok.",
  // (3) Customer #1 funnel
  "pan.fun.title": "Customer #1 hunisi",
  "pan.fun.desc": "Edinme hunisi — gerçekleşen sayımlar (tahmin yok).",
  "pan.fun.leads": "Lead",
  "pan.fun.recommendations": "Öneri",
  "pan.fun.issued": "Poliçe",
  "pan.fun.l2r": "Lead → Öneri",
  "pan.fun.r2p": "Öneri → Poliçe",
  "pan.fun.l2p": "Lead → Poliçe",
  // (4) KVKK / uyum
  "pan.kvkk.title": "KVKK / uyum",
  "pan.kvkk.consentTrend": "Onay eğilimi (izin / geri çekme)",
  "pan.kvkk.grants": "İzin",
  "pan.kvkk.withdrawals": "Geri çekme",
  "pan.kvkk.suppression": "Baskılama toplamı",
  "pan.kvkk.suppressionEmpty": "Baskılanan öğe yok.",
  "pan.kvkk.dsar": "DSAR / silme talepleri",
  "pan.kvkk.dsarEmpty": "Kayıtlı ilgili kişi başvurusu yok.",
  "pan.kvkk.dsarOpen": "açık",
  "pan.kvkk.dsarFulfilled": "tamamlandı",
  // (5) Operasyonel sağlık
  "pan.ops.title": "Operasyonel sağlık",
  "pan.ops.paidNotIssued": "Ödendi, poliçeleşmedi",
  "pan.ops.issuanceExceptions": "Poliçeleştirme istisnaları",
  "pan.ops.slaBreaches": "SLA ihlalleri",
  "pan.ops.byType": "Türe göre",
  "pan.ops.calm": "Aksiyon gerektiren durum yok.",
  // (6) Pilot scorecard (R1–R6)
  "pan.pilot.title": "Pilot scorecard (R1–R6)",
  "pan.pilot.r1": "Kanal dönüşümü",
  "pan.pilot.r2": "Motor → Sağlık",
  "pan.pilot.r3": "Hane derinliği (medyan)",
  "pan.pilot.r4": "Yenileme oranı",
  "pan.pilot.r5": "Alınan komisyon",
  "pan.pilot.r6": "Fiyat bütünlüğü",
  "pan.pilot.cacPending": "CAC (kanal harcaması) dış Finance beslemesi — bekleniyor.",
  "pan.pilot.costPending": "Danışman maliyeti dış Finance beslemesi — bekleniyor.",

  // 05 — Sigortacı Kalite Karnesi (founder layout chrome; existing keys reused)
  "sc.breadcrumbRoot": "Sigortacı Kalite",
  "sc.scoreTitle": "Genel kalite skoru",
  "sc.scoreOutOf": "/ 100",
  "sc.scoreNoMetrics": "Bu anlık görüntüde ölçülebilir metrik yok — skor üretilmedi.",
  "sc.scoreBasis": "Kullanılan metrik",
  "sc.scoreConfigVersion": "Ağırlık sürümü",
  "sc.scorePartial":
    "Kısmi skor: model metriklerinin bir kısmı eksik; ağırlıklar mevcut metrikler üzerinden yeniden normalize edildi.",
  "sc.draftEditing": "Taslak düzenleniyor",
  "sc.metricsTitle": "Kalite ölçütleri",
  "sc.metricsWeightNote":
    "Ölçüt ağırlıkları CARRIER_QUALITY governed config'inden gelir (sürümlü, tarih-etkili).",
  "sc.metricColdStart": "Bu sigortacı için henüz yeterli veri yok",
  "sc.metricColdStartBand":
    "Soğuk başlangıç — bu ölçüt yeterli gözlem birikene dek genel skora dahil edilmez.",
  "sc.historyTitle": "Sürüm geçmişi",
  "sc.historyAppendOnly": "Yalnızca ekleme",
  "sc.historyCurrent": "Güncel (en yeni as_of)",
  "sc.historyNone": "Henüz anlık görüntü yok (soğuk başlangıç).",
  "sc.auditTitle": "Denetim bilgisi",
  "sc.auditSource": "Kaynak",
  "sc.auditAsOf": "Geçerlilik (as_of)",
  "sc.auditRecorded": "Kayıt zamanı",
  "sc.auditGovernNote":
    "Governed: her kayıt denetim izine (audit) yazılır ve yalnızca ekleme (append-only) yapılır — en yeni as_of kazanır, geçmiş korunur (yeniden kurulabilirlik).",
  "sc.auditFourEyesBackendFirst":
    "Ayrı onaylı dört-göz (öneren ≠ onaylayan) yayımlama bu kaynak için backend-first: kalite endpoint'i denetimli + append-only catalog:write'tır, onay-kapılı değildir.",
  "sc.saveUnsaved": "Kaydedilmemiş değişiklikleriniz var",
  "sc.saveGovernNote":
    "Denetimli + yalnızca ekleme: kayıt yeni tarihli bir anlık görüntüdür; en yeni as_of kazanır — üzerine yazılmaz.",
  "sc.saveDiscard": "Vazgeç",

  // Müşteriler — müşteri (party) yönetimi: liste/arama, detay + düzenleme, şifre sıfırlama
  "nav.customers": "Müşteriler",
  "cust.heading": "Müşteriler",
  "cust.sub":
    "Müşterileri arayın, bilgilerini görüntüleyin ve güncelleyin. Hassas veriler yalnızca maskeli gösterilir.",
  "cust.list.title": "Müşteri listesi",
  "cust.loading": "Müşteriler yükleniyor…",
  "cust.error": "Müşteriler yüklenemedi.",
  "cust.empty.list": "Henüz müşteri yok.",
  "cust.empty.search": "Aramayla eşleşen müşteri bulunamadı.",
  "cust.search.by": "Arama ölçütü",
  "cust.search.byName": "Ad / Soyad",
  "cust.search.byPhone": "Telefon",
  "cust.search.term": "Arama",
  "cust.search.namePlaceholder": "Ad veya soyad",
  "cust.search.submit": "Ara",
  "cust.search.clear": "Temizle",
  "cust.col.name": "Ad Soyad",
  "cust.col.phone": "Telefon",
  "cust.col.email": "E-posta",
  "cust.open": "Görüntüle",
  "cust.more": "Daha fazla",
  "cust.detail.loading": "Müşteri detayı yükleniyor…",
  "cust.detail.error": "Müşteri detayı yüklenemedi.",
  "cust.account.yes": "Hesap: Var",
  "cust.account.no": "Hesap: Yok",
  "cust.field.firstName": "Ad",
  "cust.field.lastName": "Soyad",
  "cust.field.email": "E-posta",
  "cust.field.phone": "Telefon",
  "cust.field.phoneNote":
    "Telefon buradan değiştirilemez — değişiklik yeniden doğrulama gerektirir.",
  "cust.field.tckn": "TCKN (maskeli)",
  "cust.field.tcknNote": "Yalnızca maskeli gösterilir; tam TCKN ayrı ve denetimli bir işlemdir.",
  "cust.field.householdId": "Hane no",
  "cust.edit": "Düzenle",
  "cust.save": "Kaydet",
  "cust.cancel": "Vazgeç",
  "cust.save.success": "Müşteri bilgileri güncellendi.",
  "cust.toast.dismiss": "Kapat",
  "cust.readOnly": "Yalnızca okuma — düzenleme yetkiniz yok (party:write).",
  "cust.reset.title": "Şifre sıfırlama",
  "cust.reset.note":
    "Müşterinin hesabı için tek kullanımlık geçici bir parola üretir; müşteri bir sonraki girişte yeni parola belirler.",
  "cust.reset.action": "Şifre sıfırla",
  "cust.reset.confirmTitle": "Şifre sıfırlansın mı?",
  "cust.reset.confirmBody":
    "Bu müşterinin hesabı için tek kullanımlık geçici bir parola oluşturulacak. İşlem ek kimlik doğrulama (step-up) gerektirebilir.",
  "cust.reset.stepUp":
    "Bu işlem ek kimlik doğrulama (step-up) gerektiriyor — doğrulama tamamlanmadı.",
  "cust.reset.revealTitle": "Geçici parola",
  "cust.reset.revealBody":
    "Bu parolayı müşteriye yalnızca güvenli bir kanaldan (telefon) bir kez iletin. Bu ekran kapandığında tekrar gösterilmez.",
  "cust.reset.copy": "Kopyala",
  "cust.reset.copied": "Kopyalandı",
  "cust.reset.done": "İletildi, kapat",

  // Ekip — IAM personel sağlama (yeni danışman / yönetici / admin oluşturma)
  "nav.iam": "Ekip",
  "iam.heading": "Ekip",
  "iam.sub":
    "Yeni bir ekip kullanıcısı (danışman, yönetici, admin) oluşturun. Kullanıcı için tek kullanımlık geçici bir parola üretilir.",
  "iam.create.title": "Yeni kullanıcı oluştur",
  "iam.field.displayName": "Ad Soyad",
  "iam.field.displayNamePlaceholder": "Örn. Ayşe Yılmaz",
  "iam.field.email": "E-posta",
  "iam.field.role": "Rol",
  "iam.create.submit": "Kullanıcı oluştur",
  "iam.role.SUPER_ADMIN": "Süper Yönetici",
  "iam.role.ADMIN": "Yönetici",
  "iam.role.COMPLIANCE": "Uyum",
  "iam.role.OPS": "Operasyon",
  "iam.role.MANAGER": "Müdür",
  "iam.role.ADVISOR": "Danışman",
  "iam.role.CLAIMS_COORDINATOR": "Hasar Koordinatörü",
  "iam.role.FINANCE": "Finans",
  "iam.role.CONFIG_ADMIN": "Yapılandırma Yöneticisi",
  "iam.role.ANALYTICS": "Analitik",
  "iam.role.elevatedHidden":
    "Yönetici / Süper Yönetici rolleri yalnızca süper yönetici tarafından oluşturulabilir.",
  "iam.created.title": "Kullanıcı oluşturuldu",
  "iam.reveal.title": "Geçici parola",
  "iam.reveal.note":
    "Bu parola yalnızca bir kez gösterilir — kullanıcıya güvenli bir kanaldan iletin. Kullanıcı ilk girişte kendi parolasını belirleyecek.",
  "iam.reveal.copy": "Kopyala",
  "iam.reveal.copied": "Kopyalandı",
  "iam.reveal.done": "İletildi, kapat",
  "iam.error.dupEmail": "Bu e-posta zaten kayıtlı.",
  "iam.error.forbidden": "Bu rolü oluşturma yetkiniz yok.",
  "iam.error.validation": "Lütfen alanları kontrol edin.",
  "iam.error.unavailable": "Personel sağlama şu an yapılandırılmamış.",
  "iam.error.noPermission": "Bu işlem için yetkiniz yok.",
  "iam.error.notFound": "Personel bulunamadı.",
  "iam.error.conflict": "İşlem tamamlanamadı, lütfen tekrar deneyin.",
  "iam.error.generic": "İşlem tamamlanamadı.",
  "iam.list.title": "Ekip listesi",
  "iam.list.loading": "Ekip yükleniyor…",
  "iam.list.error": "Ekip yüklenemedi.",
  "iam.list.empty": "Henüz personel yok.",
  "iam.list.more": "Daha fazla",
  "iam.col.name": "Ad Soyad",
  "iam.col.email": "E-posta",
  "iam.col.role": "Rol",
  "iam.col.status": "Durum",
  "iam.status.active": "Aktif",
  "iam.status.passive": "Pasif",
  "iam.manage": "Yönet",
  "iam.manage.elevatedLocked": "Yönetici hesaplarını yalnızca süper yönetici yönetebilir.",
  "iam.edit": "Düzenle",
  "iam.edit.save": "Kaydet",
  "iam.edit.cancel": "Vazgeç",
  "iam.edit.success": "Personel güncellendi.",
  "iam.status.title": "Giriş durumu",
  "iam.status.enable": "Aktifleştir",
  "iam.status.disable": "Pasife al",
  "iam.status.selfNote": "Kendi hesabınızı pasife alamazsınız.",
  "iam.status.success": "Durum güncellendi.",
  "iam.reset.title": "Şifre sıfırla",
  "iam.reset.note": "Geçici bir parola oluşturur; personel ilk girişte kendi parolasını belirler.",
  "iam.reset.action": "Şifre sıfırla",
  "iam.reset.confirmTitle": "Şifre sıfırlansın mı?",
  "iam.reset.confirmBody":
    "Personelin geçici bir parolası oluşturulacak ve ilk girişte parola değişikliği istenecek.",
  "iam.toast.dismiss": "Kapat",

  // KVKK — Veri-sahibi talepleri (İlgili Kişi Başvuru Kaydı / DSAR)
  "nav.dsar": "KVKK talepleri",
  "dsar.heading": "KVKK — Veri-sahibi talepleri",
  "dsar.sub":
    "İlgili kişi başvurularını (KVKK m.11) kaydedin, listeleyin ve durumlarını yürütün. Yasal yanıt süresi: alındığı tarihten itibaren 30 gün.",
  "dsar.readOnly": "Bu bölümde yalnızca görüntüleme yetkiniz var.",
  "dsar.create.title": "Yeni talep kaydet",
  "dsar.create.submit": "Talebi kaydet",
  "dsar.create.dueInfo": "Yasal süre: alındı + 30 gün (otomatik hesaplanır).",
  "dsar.field.subject": "İlgili kişi (Party ID)",
  "dsar.field.subjectHint":
    "İlgili kişinin party kimliği (UUID). Aşağıdan arayarak da seçebilirsiniz.",
  "dsar.field.subjectPicked": "Seçilen: ",
  "dsar.field.type": "Talep türü",
  "dsar.field.channel": "Başvuru kanalı",
  "dsar.field.note": "Not (opsiyonel)",
  "dsar.field.notePlaceholder": "Kısa açıklama",
  "dsar.field.fulfilled": "Tamamlanma",
  "dsar.type.ACCESS": "Erişim",
  "dsar.type.ERASURE": "Silme",
  "dsar.type.RECTIFICATION": "Düzeltme",
  "dsar.type.OBJECTION": "İtiraz",
  "dsar.type.PORTABILITY": "Taşınabilirlik",
  "dsar.channel.EMAIL": "E-posta",
  "dsar.channel.PHONE": "Telefon",
  "dsar.channel.POST": "Posta",
  "dsar.channel.IN_PERSON": "Yüz yüze",
  "dsar.channel.WEB": "Web",
  "dsar.status.RECEIVED": "Alındı",
  "dsar.status.IN_PROGRESS": "İşlemde",
  "dsar.status.FULFILLED": "Tamamlandı",
  "dsar.status.REJECTED": "Reddedildi",
  "dsar.overdue": "Gecikmiş",
  "dsar.erasure.note":
    "Silme talepleri elle “Tamamlandı” yapılamaz. Kaydı açtıktan sonra “Silmeyi yürüt” adımıyla kripto-shred fiilen çalıştırılır (ADR 0002); çift-onay ve yeniden kimlik doğrulama gerekir.",
  "dsar.erasure.shred":
    "Bu bir silme talebidir. “Tamamlandı” durumu yalnızca kripto-shred gerçekten çalıştığında oluşur — aşağıdaki “Silmeyi yürüt” adımı tek yoldur.",
  "dsar.erasure.title": "Silmeyi yürüt (kripto-shred)",
  "dsar.erasure.explain":
    "Bu işlem GERİ ALINAMAZ. İlgili kişinin şifreleme anahtarları imha edilir; saklama süresi dolmamış ticari kayıtların anahtarları kilitlenir (RESTRICTED). Talep otomatik olarak Tamamlandı'ya geçer ve silme referansı kaydedilir.",
  "dsar.erasure.requestApproval": "İkinci onay iste",
  "dsar.erasure.awaiting":
    "İkinci kişinin onayı bekleniyor. Kendi talebinizi kendiniz onaylayamazsınız.",
  "dsar.erasure.execute": "Silmeyi yürüt",
  "dsar.erasure.confirm":
    "Bu kişinin verisi geri alınamaz biçimde silinecek. Devam etmek için ONAYLA yazın.",
  "dsar.erasure.confirmWord": "ONAYLA",
  "dsar.erasure.confirmLabel": "Onay metni",
  "dsar.erasure.done": "Silme yürütüldü.",
  "dsar.erasure.receipt": "Silme referansı",
  "dsar.erasure.shredded": "İmha edilen anahtar",
  "dsar.erasure.restricted": "Kilitlenen (saklama süresi dolmamış)",
  "dsar.erasure.skipped": "Zaten pasif",
  "dsar.erasure.noApprover":
    "Bu işlem için ikinci bir onaylayıcı gerekiyor (dsr.erase:approve). Tek kullanıcıyla silme yürütülemez — geri alınamaz bir işlem için bu kasıtlıdır.",
  "dsar.error.fourEyes": "İkinci kişinin onayı geçerli değil ya da tükenmiş. Yeniden onay isteyin.",
  "dsar.error.stepUp":
    "Bu işlem için yakın zamanlı güçlü kimlik doğrulama gerekiyor. Yeniden giriş yapın.",
  "dsar.picker.by": "Kişi ara",
  "dsar.picker.byName": "Ad / Soyad",
  "dsar.picker.byPhone": "Telefon",
  "dsar.picker.term": "Arama",
  "dsar.picker.namePlaceholder": "Ad veya soyad",
  "dsar.picker.search": "Ara",
  "dsar.picker.pick": "Seç",
  "dsar.picker.empty": "Eşleşen kişi bulunamadı.",
  "dsar.filter.status": "Durum",
  "dsar.filter.type": "Tür",
  "dsar.filter.any": "Tümü",
  "dsar.list.title": "Talep listesi",
  "dsar.list.loading": "Talepler yükleniyor…",
  "dsar.list.error": "Talepler yüklenemedi.",
  "dsar.list.empty": "Kayıtlı talep yok.",
  "dsar.list.more": "Daha fazla",
  "dsar.col.subject": "İlgili kişi",
  "dsar.subject.unresolved": "İlgili kişinin adı çözümlenemedi; party kimliği (UUID) gösteriliyor.",
  "dsar.col.type": "Tür",
  "dsar.col.status": "Durum",
  "dsar.col.received": "Alındığı tarih",
  "dsar.col.due": "Son tarih",
  "dsar.manage": "Yönet",
  "dsar.transition.title": "Durumu ilerlet",
  "dsar.transition.terminal": "Bu talep sonuçlandı; başka bir işlem yapılamaz.",
  "dsar.transition.success": "Durum güncellendi.",
  "dsar.error.forbidden": "Bu işlem için yetkiniz yok.",
  "dsar.error.notFound": "Talep bulunamadı.",
  "dsar.error.conflict": "Bu durum geçişi yapılamaz.",
  "dsar.error.validation": "Lütfen alanları kontrol edin.",
  "dsar.error.generic": "İşlem tamamlanamadı.",
  "dsar.toast.dismiss": "Kapat",
} as const;

export type AdminMessageKey = keyof typeof tr;
export type MessageKey = BaseMessageKey | AdminMessageKey;

export const en: Record<AdminMessageKey, string> = {
  "app.title": "CSA Privé — Admin Console",
  "nav.catalog": "Carrier Quality",

  // Top-nav shell (04) — brand-adjacent section label, language, and role
  "shell.section": "Management",
  "shell.role.staff": "Manager",
  "shell.role.party": "Member",
  "shell.role.service": "Service",
  // Governance signals — persistent audit strip and return-to-advisor-console link
  "shell.audit": "Every view and change is written to the audit log · fresh-auth.",
  "shell.backToConsole": "Back to Advisor Console",
  // Left-rail section headings (nav clusters; presentation only)
  "nav.section.overview": "Overview",
  "nav.section.catalog": "Catalog & Pricing",
  "nav.section.relations": "Customers & Marketing",
  "nav.section.governance": "Compliance & Governance",
  "nav.section.team": "Team",

  "catalog.heading": "Carrier-Quality Scorecard",
  "catalog.pickCarrier": "Select carrier",
  "catalog.selectPrompt": "Select a carrier to curate its scorecard.",
  "catalog.loadingCarriers": "Loading carriers…",
  "catalog.carriersError": "Failed to load carriers.",
  "catalog.noCarriers": "No carriers found.",
  "catalog.type": "Type",
  "catalog.status": "Status",

  "quality.loading": "Loading scorecard…",
  "quality.coldStart": "No scorecard yet — write the first snapshot (cold-start).",
  "quality.latestHeading": "Latest snapshot",
  "quality.source": "Source",
  "quality.asOf": "As of",
  "quality.appendOnlyNote":
    "Each write is a new dated snapshot; the latest (as_of) wins — append-only, never an edit.",

  "metric.claimsPaymentSpeedDays": "Claims payment speed (days)",
  "metric.claimsAcceptanceRatio": "Claims acceptance ratio",
  "metric.complaintRatio": "Complaint ratio",
  "metric.serviceScore": "Service score",
  "metric.solvencyRatio": "Solvency ratio",
  "metric.networkStrength": "Network strength",
  "metric.claimsPaymentSpeedDays.help":
    "How many days the carrier takes to pay after approving a claim (days). Lower = better.",
  "metric.claimsAcceptanceRatio.help":
    "Share of filed claims that are accepted (0–1, e.g. 0.95). Higher = better.",
  "metric.complaintRatio.help": "Complaints per policy (0–1, small values). Lower = better.",
  "metric.serviceScore.help":
    "Overall service / customer-satisfaction score (0–100). Higher = better.",
  "metric.solvencyRatio.help":
    "The carrier's solvency (paying-capacity) ratio (a ratio, usually above 1). Higher = stronger.",
  "metric.networkStrength.help":
    "Breadth of the contracted service/hospital network, as a score (0–100). Higher = better.",

  "form.heading": "Write a CURATED snapshot",
  "form.asOf": "As-of date (optional)",
  "form.asOfHint": "The date this score applies from. Left blank, today's date is used.",
  "form.curate": "Curate",
  "form.atLeastOne": "Enter at least one metric.",
  "form.invalidMetric": "Non-negative decimal; up to 8 integer and 4 decimal digits.",
  "form.invalidAsOf": "Invalid date — must be ISO-8601 with a timezone offset.",
  "form.readOnly": "Read-only — you lack the curate grant (catalog:write).",
  "form.success": "CURATED snapshot written.",

  // Catalog management — self-service carrier + version + branch authorization
  "nav.catalogMgmt": "Catalog",
  "cat.heading": "Catalog — Carrier Management",
  "cat.loading": "Loading carriers…",
  "cat.empty": "No carriers yet — add the first one below.",
  "cat.list.title": "Carriers",
  "cat.carriersError": "Failed to load carriers.",
  "cat.detailEyebrow": "Carrier",
  "cat.appendOnlyTag": "Append-only",
  "cat.detail": "Detail",
  "cat.readOnly": "Read-only — you lack the catalog write grant (catalog:write).",
  "cat.list.code": "Code",
  "cat.list.tradeName": "Trade name",
  "cat.list.type": "Type",
  "cat.list.status": "Status",
  "cat.type.CONVENTIONAL": "Conventional",
  "cat.type.KATILIM": "Participation (Katılım)",
  "cat.status.ACTIVE": "Active",
  "cat.status.SUSPENDED": "Suspended",
  "cat.status.WITHDRAWN": "Withdrawn",
  "cat.versions.heading": "Version history",
  "cat.versions.loading": "Loading versions…",
  "cat.versions.empty": "No versions.",
  "cat.versions.version": "Version",
  "cat.versions.legalName": "Legal name",
  "cat.versions.window": "Effective window",
  "cat.versions.current": "Current",
  "cat.versions.add": "Append a version",
  "cat.versions.appendOnlyNote":
    "Versions are appended (append-only): the open version is closed and a new one opens — the current version is never edited, history is preserved.",
  "cat.versions.submit": "Add version",
  "cat.versions.success": "New version appended.",
  "cat.auth.heading": "Branch authorizations",
  "cat.linesLoadFailed":
    "The branch list could not be read — the form cannot be submitted. Try again.",
  "comm.form.fromRequired": "A start date is required.",
  "cat.auth.loading": "Loading authorizations…",
  "cat.auth.empty": "No branch authorizations defined.",
  "cat.auth.line": "Line",
  "cat.auth.from": "From",
  "cat.auth.to": "To (optional)",
  "cat.auth.open": "Open",
  "cat.auth.add": "Authorize a branch",
  "cat.auth.submit": "Authorize",
  "cat.auth.success": "Branch authorization recorded.",
  "cat.auth.conflict": "This carrier already holds an open authorization for that line.",
  "cat.auth.invalidTo": "Invalid date — must be ISO-8601 with a timezone offset.",
  "cat.auth.toHint": "Optional; blank = an open-ended (open) authorization.",
  "cat.carrier.add": "Add a carrier",
  "cat.carrier.governedNote":
    "A new carrier is created with an immutable identity (code) and its first version. Later changes are appended as new versions (append-only); the write is recorded in the audit trail.",
  "cat.carrier.codeHint": "Lowercase-kebab (e.g. allianz-sigorta); the immutable identity.",
  "cat.carrier.invalidCode": "Must be lowercase-kebab: e.g. allianz-sigorta.",
  "cat.carrier.submit": "Add carrier",
  "cat.carrier.success": "Carrier added.",
  "cat.carrier.conflict": "That code is already in use — choose a different one.",

  // Catalog management — section tabs (carriers · products · packages · concepts)
  "catmgmt.tabsLabel": "Catalog sections",
  "catmgmt.tab.carriers": "Carriers",
  "catmgmt.tab.products": "Products",
  "catmgmt.tab.packages": "Packages",
  "catmgmt.tab.concepts": "Concepts & Coverages",

  // Products
  "prod.heading": "Catalog — Product Management",
  "prod.governedNote":
    "A product is created with an immutable identity (code · carrier · line) and its first version. Later changes are appended as new versions (append-only), recorded in the audit trail.",
  "prod.list.title": "Products",
  "prod.list.empty": "No products in the catalog yet.",
  "prod.list.loading": "Loading products…",
  "prod.list.picked": "Selected",
  "prod.lookup.title": "Look up a product by code",
  "prod.lookup.note":
    "If you know the code, fetch it directly; otherwise pick from the list above.",
  "prod.lookup.submit": "Fetch",
  "prod.loading": "Loading product…",
  "prod.notFound": "No product found for that code.",
  "prod.detailEyebrow": "Product",
  "prod.current": "Current version",
  "prod.salesStatus": "Sales status",
  "prod.targetSegment": "Target segment",
  "prod.sales.ACTIVE": "On sale",
  "prod.sales.PAUSED": "Paused",
  "prod.sales.DISCONTINUED": "Discontinued",
  "prod.name": "Product name",
  "prod.carrier": "Carrier",
  "prod.codeHint": "Lowercase-kebab (e.g. allianz-tamamlayici); immutable identity.",
  "prod.version.add": "Append a product version",
  "prod.version.submit": "Add version",
  "prod.version.success": "New product version appended.",
  "prod.add": "Add a product",
  "prod.submit": "Add product",
  "prod.success": "Product added.",

  // Packages (the quotable unit; the coverage-set freezes with the version)
  "pkg.heading": "Catalog — Package Management",
  "pkg.governedNote":
    "A package is the quotable unit; its coverage-set is pinned and frozen when the version is created. The identity (code · product) is immutable; changes are appended as new versions.",
  "pkg.list.title": "Distributable packages",
  "pkg.list.name": "Package name",
  "pkg.list.carrier": "Carrier",
  "pkg.pickLine": "Pick a line…",
  "pkg.pickLinePrompt": "Pick a line to list its packages.",
  "pkg.loading": "Loading packages…",
  "pkg.error": "Failed to load packages.",
  "pkg.empty": "No distributable packages for this line.",
  "pkg.detailEyebrow": "Package",
  "pkg.notFound": "No package found for that code.",
  "pkg.pinned.title": "Pinned coverage-set",
  "pkg.pinned.frozenNote":
    "This set was pinned to the coverages' current versions and frozen when the version was created — changing it requires a new package version.",
  "pkg.pinned.empty": "No pinned coverages.",
  "pkg.pinned.role": "Role",
  "pkg.pinned.pinnedVersion": "Pinned version",
  "pkg.pinned.limit": "Limit",
  "pkg.pinned.unlimited": "Unlimited",
  "pkg.name": "Package name",
  "pkg.renewal": "Renewal guarantee",
  "pkg.renewal.NONE": "None",
  "pkg.renewal.CONDITIONAL": "Conditional",
  "pkg.renewal.LIFETIME": "Lifetime",
  "pkg.preexisting": "Pre-existing handling",
  "pkg.preexisting.NOT_APPLICABLE": "Not applicable",
  "pkg.preexisting.EXCLUDED": "Excluded",
  "pkg.preexisting.COVERED_AFTER_WAITING": "Covered after waiting",
  "pkg.preexisting.UNDERWRITTEN": "Underwritten",
  "pkg.minEntryAge": "Min. entry age",
  "pkg.maxEntryAge": "Max. entry age",
  "pkg.networkCode": "Network code",
  "pkg.networkHint": "Required only on networked lines (e.g. tss/oss).",
  "pkg.covset.title": "Coverage-set",
  "pkg.covset.pinTag": "Pinned",
  "pkg.covset.note":
    "At least one coverage. Each is resolved to its current version server-side and frozen with the version.",
  "pkg.covset.coverageCode": "Coverage code",
  "pkg.covset.role": "Role",
  "pkg.covset.remove": "Remove",
  "pkg.covset.addRow": "Add coverage",
  "pkg.role.CORE": "Core",
  "pkg.role.RIDER": "Rider",
  "pkg.role.OPTIONAL": "Optional",
  "pkg.version.add": "Append a package version",
  "pkg.version.note":
    "Versions are appended (append-only): the open version is closed and a new one opens with a fresh coverage-set — the current version is never edited.",
  "pkg.version.submit": "Add version",
  "pkg.version.success": "New package version appended.",
  "pkg.add": "Add a package",
  "pkg.submit": "Add package",
  "pkg.success": "Package added.",
  "pkg.codeHint": "Lowercase-kebab; immutable identity.",
  "pkg.productCode": "Product code",
  "pkg.productCodeHint": "The code of the product this package belongs to.",

  // Concepts (per line) & coverages
  "cpt.heading": "Catalog — Concepts & Coverages",
  "cpt.governedNote":
    "Canonical concepts are per line; coverages are the carrier attribute blocks pinned into packages. The concept–coverage equivalence mapping is four-eyes governed (see below).",
  "cpt.list.title": "Canonical concepts",
  "cpt.pickLine": "Pick a line…",
  "cpt.pickLinePrompt": "Pick a line to list its concepts.",
  "cpt.loading": "Loading concepts…",
  "cpt.error": "Failed to load concepts.",
  "cpt.empty": "No concepts defined for this line.",
  "cpt.name": "Name",
  "cpt.definition": "Definition",
  "cpt.add": "Add a concept",
  "cpt.submit": "Add concept",
  "cpt.success": "Concept added.",
  "cpt.equiv.title": "Equivalence mapping",
  "cpt.equiv.fourEyesTag": "Four-eyes",
  "cpt.equiv.flag":
    "The coverage–concept equivalence mapping and its confirmation are four-eyes governed (POST /equivalences, @RequireFourEyes). That governed propose/confirm flow is not built in this release — flagged as a follow-on.",

  // Coverages (create is NOT four-eyes; only equivalence is)
  "cov.lookup.title": "Look up a coverage by code",
  "cov.lookup.note":
    "There is no coverage list endpoint — a coverage is retrieved by its immutable code (GET /coverages/:code).",
  "cov.loading": "Loading coverage…",
  "cov.notFound": "No coverage found for that code.",
  "cov.detailEyebrow": "Coverage",
  "cov.name": "Coverage name",
  "cov.limit": "Limit",
  "cov.unlimited": "Unlimited",
  "cov.subLimits": "Sub-limits",
  "cov.limitAmount": "Limit amount",
  "cov.deductibleAmount": "Deductible amount",
  "cov.coPayPercent": "Co-pay (%)",
  "cov.geographicScope": "Geographic scope",
  "cov.limitUnlimited": "Unlimited",
  "cov.moneyHint": "Decimal string; up to 2 places (e.g. 100000.00).",
  "cov.percentHint": "Percent as a decimal string (e.g. 20 or 20.00).",
  "cov.invalidMoney": "Invalid amount — non-negative decimal, up to 2 places.",
  "cov.invalidPercent": "Invalid percent — must be a decimal string.",
  "cov.add": "Add a coverage",
  "cov.submit": "Add coverage",
  "cov.success": "Coverage added.",
  "cov.governedNote":
    "A coverage is created with an immutable identity (code · carrier · line) and its first version; changes are appended as new versions. Coverage creation is NOT four-eyes (only equivalence mapping is).",

  // AL2b — Commission rates
  "nav.commissionRates": "Commission",
  "comm.heading": "Commission Rates",
  "comm.subheading":
    "Carrier·line·product rates — calm, effective-dated and append-only (change = close + new period).",
  "comm.list.title": "Current & historical rates",
  "comm.appendOnlyTag": "Append-only",
  "comm.filter.carrier": "By carrier",
  "comm.filter.line": "By line",
  "comm.filter.all": "All",
  "comm.loading": "Loading rates…",
  "comm.error": "Failed to load rates.",
  "comm.coldStart": "No rates defined yet.",
  "comm.list.carrier": "Carrier",
  "comm.list.line": "Line",
  "comm.list.product": "Product",
  "comm.list.rate": "Rate",
  "comm.list.from": "From",
  "comm.list.to": "To / Status",
  "comm.allProducts": "all products",
  "comm.current": "Current",
  "comm.history": "history",
  "comm.form.heading": "Add a rate",
  "comm.form.appendOnlyNote":
    "Rates are added (a new dated row); an existing open rate is not edited — changing it needs the governed path.",
  "comm.form.carrier": "Carrier",
  "comm.form.line": "Line",
  "comm.form.product": "Product (optional)",
  "comm.form.productHint": "Blank = whole line (a product id for a product-level rate)",
  "comm.form.rate": "Rate (%)",
  "comm.form.invalidRate": "Percent in (0,100], up to 2 decimals — not rounded.",
  "comm.form.effectiveFrom": "Effective from (ISO-8601 with offset)",
  "comm.form.invalidFrom": "Invalid date — must be ISO-8601 with a timezone offset.",
  "comm.form.effectiveTo": "Effective to (optional, after from)",
  "comm.form.effectiveToHint": "Optional; must be after effective-from.",
  "comm.form.invalidTo": "Must be after effective-from, ISO-8601 with offset.",
  "comm.form.save": "Save rate",
  "comm.form.readOnly": "Read-only — you lack the write grant (commission:write).",
  "comm.form.success": "Rate saved.",
  "comm.form.conflict":
    'A current rate exists for this scope. To change it, use "Change rate" on the current rate in the list.',
  "comm.list.actions": "Actions",
  "comm.change.action": "Change rate",
  "comm.change.heading": "Change rate (close + new period)",
  "comm.change.note":
    "The current rate is closed and a new dated rate opens — never overwritten, history preserved.",
  "comm.change.newRate": "New rate (%)",
  "comm.change.effectiveFrom": "Effective from (optional)",
  "comm.change.effectiveFromHint": "Blank = now; must be after the current rate's start.",
  "comm.change.submit": "Save change",
  "comm.change.cancel": "Cancel",
  "comm.change.success": "Rate changed — the prior closed, the new one open.",

  // AL3 — Score-Registry config governance
  "nav.config": "Configuration",
  // Marketing console (MK-FE)
  // #291 — CR-1b saved-segment authoring
  "seg.title": "Saved segments",
  "seg.sub":
    "Composed from governed primitives; evaluated per advisor book. Commission appears nowhere.",
  "seg.loading": "Loading…",
  "seg.loadError": "Could not load segments",
  "seg.loadErrorDesc": "The list could not be read; try again.",
  "seg.empty": "No saved segments yet",
  "seg.emptyDesc": "Author the first one below from the governed primitives.",
  "seg.ruleCount": "{n} rules",
  "seg.match.ALL": "All rules (AND)",
  "seg.match.ANY": "Any rule (OR)",
  "seg.status.ACTIVE": "Active",
  "seg.status.ARCHIVED": "Archived",
  "seg.archive": "Archive",
  "seg.updateError": "Could not update the segment.",
  "seg.new": "New segment",
  "seg.newSub": "A name + a match mode + at least one rule. Params are validated server-side.",
  "seg.name": "Segment name",
  "seg.namePlaceholder": "e.g. Renewing within 30 days",
  "seg.matchLabel": "Match mode",
  "seg.rules": "Rules",
  "seg.noRules": "No rules yet — add one below.",
  "seg.primitive": "Primitive",
  "seg.addRule": "Add rule",
  "seg.removeRule": "Remove",
  "seg.create": "Create segment",
  "seg.createError": "Could not create the segment — check the parameters.",
  "mk.heading": "Marketing",
  "mk.subtitle":
    "Governed communication — not a blast tool. Every send passes the server-side gates.",
  "mk.iys.title": "İYS status",
  "mk.iys.registration": "Registration",
  "mk.iys.registrationValue": "Not registered",
  "mk.iys.send": "Send",
  "mk.iys.sendValue": "Pilot · off",
  "mk.iys.residency": "Data residency",
  "mk.iys.residencyValue": "TR · WhatsApp egress-gated",
  "mk.sendDeferred":
    "Send is deferred (residency + İYS pending). This console dispatches nothing; it only evaluates.",
  "mk.loading": "Loading…",
  "mk.error.title": "Something went wrong",
  "mk.error.detail": "Could not load the data.",
  "mk.readOnly": "You can view this surface; defining a campaign needs marketing:manage.",
  "mk.error.noPermission": "You do not have permission for this action.",
  "mk.error.unavailable": "The service is unavailable right now; try again shortly.",
  "mk.error.validation": "The input is invalid; check the fields.",
  "mk.trigger.title": "Lifecycle triggers",
  "mk.trigger.intro":
    "Each trigger scores a cohort through the same no-spam gates — nothing is sent, definition only.",
  "mk.trigger.renewalDue": "Renewal approaching (≤30 days)",
  "mk.trigger.coverageGap": "Coverage gap (uninsured vehicle)",
  "mk.trigger.households": "households",
  "mk.audience.title": "Reachability ledger",
  "mk.audience.gate": "Suppression thresholds (touch-cap)",
  "mk.audience.channel": "Channel",
  "mk.audience.reachable": "Reachable",
  "mk.audience.noConsent": "No consent",
  "mk.audience.careHold": "Care-hold",
  "mk.audience.coolOff": "Cool-off",
  "mk.audience.touchCap": "Touch-cap",
  "mk.audience.book": "Book",
  "mk.attr.title": "Source → conversion",
  "mk.attr.leads": "Leads",
  "mk.attr.conversions": "Conversions",
  "mk.attr.source": "Source",
  "mk.attr.rate": "Rate",
  "mk.attr.cac": "CAC",
  "mk.attr.external": "External feed",
  "mk.campaign.title": "Campaigns",
  "mk.campaign.name": "Name",
  "mk.campaign.channel": "Channel",
  "mk.campaign.segment": "Segment",
  "mk.campaign.create": "Create",
  "mk.campaign.statusCol": "Status",
  "mk.campaign.action": "Action",
  "mk.campaign.resolve": "Resolve",
  "mk.campaign.activate": "Activate",
  "mk.campaign.close": "Close campaign",
  "mk.campaign.empty.title": "No campaigns",
  "mk.campaign.empty.desc": "Define a consent-bounded campaign; nothing is sent.",
  "mk.campaign.status.draft": "Draft",
  "mk.campaign.status.active": "Active",
  "mk.campaign.status.closed": "Closed",
  "mk.campaign.eligible": "eligible",
  "mk.campaign.suppressed": "suppressed",
  "cfg.heading": "Config Governance (Score Registry)",
  "cfg.subheading":
    "The governed change path: propose → (four-eyes) a second person approves → activate. Versions are append-only.",
  "cfg.registryTitle": "Score-registry namespaces",
  "cfg.governNote":
    "Governance is server-enforced; proposer ≠ approver (four-eyes), versions append-only.",
  "cfg.appendOnlyTag": "Append-only",
  "cfg.appendOnlyNote":
    "Every version is new and immutable; the active version changes, history is never edited — append, not edit.",
  "cfg.loading": "Loading…",
  "cfg.namespace": "Namespace",
  "cfg.governance": "Governance",
  "cfg.active": "Active version",
  "cfg.noActive": "No active version",
  // Score-registry namespaces — human title + what it does. The code (PRIORITY etc.)
  // is kept below as the technical identity.
  "cfg.ns.PRIORITY.title": "Priority scoring",
  "cfg.ns.PRIORITY.desc": "Weights that decide the order work surfaces in the daily queue.",
  "cfg.ns.RENEWAL_CADENCE.title": "Renewal cadence",
  "cfg.ns.RENEWAL_CADENCE.desc":
    "How many days before expiry, and at what intervals, a renewing customer is contacted.",
  "cfg.ns.GAP_RULES.title": "Coverage-gap rules",
  "cfg.ns.GAP_RULES.desc":
    "Defines which coverage gaps in a household are flagged as opportunities.",
  "cfg.ns.SUPPRESSION_GATES.title": "Suppression gates",
  "cfg.ns.SUPPRESSION_GATES.desc":
    "The order a touch is blocked: care-hold → consent → cool-off → touch cap.",
  "cfg.ns.LAWFUL_BASIS_MAP.title": "Lawful-basis map",
  "cfg.ns.LAWFUL_BASIS_MAP.desc":
    "Binds each interaction type to its KVKK lawful basis (consent / contract / legitimate interest).",
  "cfg.ns.RECONCILIATION.title": "Reconciliation thresholds",
  "cfg.ns.RECONCILIATION.desc":
    "How far a commission statement may deviate from the expected amount before it counts as a variance.",
  "cfg.ns.CARRIER_QUALITY.title": "Carrier-quality weights",
  "cfg.ns.CARRIER_QUALITY.desc":
    "Weights of the components behind the carrier-quality score (commission never enters ranking).",
  "cfg.manage": "Manage",
  "cfg.version": "Version",
  "cfg.history": "Version history",
  "cfg.badge.fourEyes": "Four-eyes (two-person)",
  "cfg.badge.normal": "Normal admin",
  "cfg.status.DRAFT": "Draft",
  "cfg.status.PENDING_APPROVAL": "Awaiting approval",
  "cfg.status.ACTIVE": "Active",
  "cfg.status.SUPERSEDED": "Superseded",
  "cfg.status.REJECTED": "Rejected",
  "cfg.propose.heading": "Propose a new version",
  "cfg.propose.readOnly": "Read-only — you lack the propose grant (config:propose).",
  "cfg.propose.payload": "Value (JSON)",
  "cfg.propose.payloadHint":
    "The new configuration value for this namespace (JSON). The change goes to approval (four-eyes).",
  "cfg.propose.changeReason": "Change reason (optional)",
  "cfg.propose.changeReasonHint":
    "Briefly note why you're making this change — it is recorded in the audit trail.",
  "cfg.propose.submit": "Propose",
  "cfg.propose.invalidJson": "Invalid JSON — the value must be an object.",
  "cfg.propose.success": "Version proposed.",
  "cfg.requestApproval": "Request approval",
  "cfg.awaitingApprover": "Awaiting the second approver",
  "cfg.activate": "Activate",
  "cfg.reject": "Reject",
  "cfg.rejectReason": "Rejection reason:",
  "cfg.timeTravel.heading": "Time-travel (as of an instant)",
  "cfg.timeTravel.at": "Date",
  "cfg.timeTravel.go": "Fetch",
  "df.today": "Today",
  "df.now": "Now",
  "cfg.inbox.heading": "Approver Inbox",
  "cfg.inbox.subtitle": "Requests awaiting your approval (the second person)",
  "cfg.inbox.fourEyesNote":
    "A proposer cannot approve their own request — the server excludes your requests from your awaiting list.",
  "cfg.inbox.loading": "Loading…",
  "cfg.inbox.none": "No pending approvals.",
  "cfg.inbox.loadFailed":
    "The approval inbox could not be read. This does NOT mean there are none.",
  "prod.list.loadFailed":
    "The product list could not be read. This does NOT mean the catalog is empty.",
  "pan.exportFailed": "The export failed. No file was produced.",
  "mk.segmentsLoadFailed":
    "The segment list could not be read, so campaigns cannot be created. This does NOT mean there are none.",
  "sc.historyLoadFailed":
    "The score history could not be read. This does NOT mean it was never scored.",
  "cfg.inbox.rejectConfirm": "Confirm rejection",
  "cfg.inbox.actionFailed": "The approval could not be recorded. No decision was made.",
  "cfg.rejectFailed": "The version could not be rejected. Its state is unchanged.",
  "cfg.activateFailed": "The version could not be activated. The active version is unchanged.",
  "cfg.requestFailed": "The approval request could not be opened.",
  "common.offline": "No connection. The request never reached the server.",
  "cfg.inbox.resource": "Resource",
  "cfg.inbox.requester": "Requested by",
  "cfg.inbox.approve": "Approve",
  "cfg.inbox.reject": "Reject",
  "cfg.inbox.review": "Review",
  "cfg.inbox.noReview": "No review screen for this action",
  "cfg.inbox.rejectReason": "Rejection reason:",

  // U10-REPORTS-F — Management pilot-scorecard dashboard (consumes the 6 metrics reads)
  "nav.reports": "Reports",
  "nav.marketing": "Marketing",
  "rep.heading": "Pilot Scorecard",
  "rep.subheading":
    "The Customer #1 pilot evidence loop — six aggregate reads (server-side rollup; no client-side aggregation).",
  "rep.cohortFrom": "Cohort from (onboarded)",
  "rep.cohortTo": "Cohort to (onboarded)",
  "rep.windowFrom": "Window from",
  "rep.windowTo": "Window to",
  "rep.cohortHint":
    "The pilot cohort — the onboard-date range of households/leads. Blank = unbounded.",
  "rep.windowHint":
    "The measurement window — the event date range (issuance, renewal, commission). Blank = unbounded.",
  "rep.loading": "Loading metric…",
  "rep.error": "Failed to load metric.",
  "rep.emptyRows": "No rows for this cohort/window (a real zero).",
  "rep.rate": "Rate",
  "rep.total": "Total",
  "rep.mean": "Mean",
  "rep.median": "Median",
  "rep.min": "Min",
  "rep.max": "Max",
  "rep.yes": "Yes",
  "rep.no": "No",
  "rep.externalPending": "External feed pending",
  "rep.periodAll": "All time",
  "rep.cohortChip": "Cohort",
  "rep.windowChip": "Window",
  "rep.kpi.conversion": "Source conversion",
  "rep.kpi.conversionNote": "total leads → policy",
  "rep.kpi.motorHealth": "Motor → health",
  "rep.kpi.motorHealthNote": "cross-sell",
  "rep.kpi.retention": "Retention",
  "rep.kpi.retentionNote": "renewal rate",
  "rep.kpi.priceIntegrity": "Price integrity",
  "rep.kpi.priceIntegrityNote": "match rate",

  "rep.r1.title": "1 — Conversion by source",
  "rep.r1.desc": "Cohort leads (lead.source) → issued policy + rate. Numerator only.",
  "rep.r1.cacPending":
    "The CAC denominator (channel spend) is the external Finance feed (gap A) — joined outside this read, never faked.",
  "rep.r1.source": "Source",
  "rep.r1.leads": "Leads",
  "rep.r1.conversions": "Conversions",

  "rep.r2.title": "2 — Motor → health conversion",
  "rep.r2.desc":
    "Motor households (denominator) → later health line (numerator), rate, median days.",
  "rep.r2.converted": "converted",
  "rep.r2.motorHh": "motor households",
  "rep.r2.medianDays": "Median days to convert",
  "rep.r2.sameDayAttach": "Same-day attach (excluded)",
  "rep.r2.crossSellIntent": "CROSS_SELL-intent households",

  "rep.r3.title": "3 & 5 — Household depth",
  "rep.r3.attach": "Multi-life attach (lives per health household)",
  "rep.r3.healthHh": "Health households",
  "rep.r3.depth": "Household depth (policies per household)",
  "rep.r3.households": "Households",

  "rep.r4.title": "4 — Retention / renewal",
  "rep.r4.desc": "Renewal-eligible (denominator) → renewed / lapsed, retention rate.",
  "rep.r4.renewed": "renewed",
  "rep.r4.eligible": "eligible",
  "rep.r4.lapsed": "lapsed",

  "rep.r5.title": "6 — Advisor unit economics",
  "rep.r5.desc":
    "Per advisor: commission (received/expected), households, policies, revenue-per-household. Revenue side only.",
  "rep.r5.costPending":
    "Advisor cost is the external Finance feed (gap A) — joined outside this read, never faked.",
  "rep.r5.advisor": "Advisor",
  "rep.r5.households": "Households",
  "rep.r5.policies": "Policies",
  "rep.r5.received": "Commission received",
  "rep.r5.expected": "Commission expected",
  "rep.r5.revPerHh": "Revenue / household",

  "rep.r6.title": "7 — Premium-experience panel",
  "rep.r6.priceIntegrity": "Price integrity",
  "rep.r6.matched": "matched",
  "rep.r6.checked": "checked",
  "rep.r6.issuanceSpeed": "Issuance speed",
  "rep.r6.issued": "Issued",
  "rep.r6.medianHours": "Median hours",
  "rep.r6.p90Hours": "p90 hours",
  "rep.r6.maxHours": "Max hours",
  "rep.r6.noSpam": "No-spam (touch-cap)",
  "rep.r6.households": "Households",
  "rep.r6.maxTouches": "Max touches",
  "rep.r6.meanTouches": "Mean touches",
  "rep.r6.breaches": "Breaches",
  "rep.r6.touchCap": "Touch-cap (config)",
  "rep.r6.noConfig": "No active config",
  "rep.r6.claimsAdvocacy": "Claims advocacy",
  "rep.r6.paid": "paid",
  "rep.r6.resolved": "resolved",
  "rep.r6.claims": "Claims",
  "rep.r6.firstResponse": "First response (median hours)",
  "rep.r6.resolution": "Resolution (median days)",
  "rep.r6.satisfaction": "Satisfaction (1–5)",
  "rep.r6.namedAdvisor": "Named advisor",
  "rep.r6.singleOwner": "Single-owner integrity",
  "rep.r6.reassignments": "Reassignments",

  // Advisor service-quality board (per-advisor service quality — /advisor-performance)
  "rep.ap.heading": "Advisor service quality",
  "rep.ap.subheading":
    "Per-advisor service quality — ordered by name, not ranked, economics excluded. Realized + current-state; no forecast. Every figure is auditable at source.",
  "rep.ap.asOf": "As of",
  "rep.ap.empty": "No advisors in scope (a real empty — never a fabricated number).",
  "rep.ap.sla": "SLA adherence",
  "rep.ap.onTime": "on time",
  "rep.ap.open": "Open",
  "rep.ap.atRisk": "At risk",
  "rep.ap.breached": "Breached",
  "rep.ap.retention": "Renewal retention",
  "rep.ap.conversion": "Offer → accept",
  "rep.ap.offersSent": "Offers sent",
  "rep.ap.accepted": "accepted",
  "rep.ap.claims": "Claims advocacy",
  "rep.ap.claimsCount": "Claims",
  "rep.ap.resolved": "Resolved",
  "rep.ap.resolutionDays": "Resolution (median days)",
  "rep.ap.satisfaction": "Satisfaction (1–5)",
  "rep.ap.paid": "paid",
  "rep.ap.depth": "Household depth",
  "rep.ap.noSpam": "No-spam discipline",
  "rep.ap.suppressed": "Suppressed items",
  "rep.ap.capBreaches": "Touch-cap breaches",
  "rep.ap.careHold": "Care-hold handling",
  "rep.ap.careHoldHh": "Care-hold households",

  // 04 — Management Panel (dashboard / home)
  "nav.dashboard": "Panel",
  "dash.heading": "Management Panel",
  "dash.period": "This month",
  "dash.greetingPre": "Hello —",
  "dash.greetingApprovals": "governed approval(s)",
  "dash.greetingPost": "awaiting you.",
  "dash.greetingNone": "no governed approvals awaiting you.",
  "dash.restricted": "You lack access to some sections of this panel.",
  "dash.backendFirst": "Backend-first",
  "dash.kpi.activePolicies": "Active policies",
  "dash.kpi.newLeads": "New leads this month",
  "dash.kpi.pendingApprovals": "Pending approvals",
  "dash.kpi.claimResolution": "Claim resolution (median days)",
  "dash.badge.fourEyes": "Four-eyes",
  "dash.kpi.noComposite": "No aggregate read for this KPI — backend-first (not fabricated).",
  "dash.kpi.leadWindow": "Leads onboarded this month (conversion-by-source · real read).",
  "dash.kpi.pendingReal": "Governed approvals in your inbox (awaiting-me) · real read.",
  "dash.kpi.claimReal": "premium-experience · claim-resolution median (days) · real read.",
  "dash.carriers.title": "Carrier quality scorecard",
  "dash.carriers.manageAll": "Manage all →",
  "dash.carriers.colCarrier": "Carrier",
  "dash.carriers.colScore": "Quality score",
  "dash.carriers.colTrend": "Trend",
  "dash.carriers.colType": "Type",
  "dash.carriers.colStatus": "Status",
  "dash.carriers.loading": "Loading carriers…",
  "dash.carriers.error": "Failed to load carriers.",
  "dash.carriers.empty": "No carriers found.",
  "dash.carriers.scorePending":
    "Aggregate quality score / trend is backend-first: the score is governed server-side, the list read has no composite, and it is never computed in the browser.",
  "dash.chart.title": "Last 6 months · new leads",
  "dash.chart.backendFirst": "No monthly time-series read — backend-first. No fake curve drawn.",
  "dash.audit.title": "Audit log",
  "dash.audit.seeAll": "Approver inbox →",
  "dash.audit.backendFirst":
    "No historical audit-log read (GET) exists — backend-first. Below shows the real pending governed approvals (awaiting-me).",
  "dash.audit.pendingTitle": "Pending governed approvals",
  "dash.audit.colAction": "Action",
  "dash.audit.colRequester": "Requested by",
  "dash.audit.colStatus": "Status",
  "dash.audit.statusPending": "Awaiting approval",
  "dash.audit.loading": "Loading…",
  "dash.audit.empty": "No governed approvals awaiting.",

  // Platform Panel (#204) — /v1/metrics/admin-platform composed read; 6 sections, honest-empty
  "pan.subtitle": "Platform health, curation and compliance — at a glance.",
  "pan.export": "Download CSV",
  "pan.asOf": "As of",
  "pan.cohort": "Cohort",
  "pan.window": "Window",
  "pan.periodAll": "All time",
  "pan.loading": "Loading panel…",
  "pan.error": "Failed to load panel data.",
  // (1) Curation coverage
  "pan.cur.title": "Curation coverage",
  "pan.cur.curated": "Curated",
  "pan.cur.total": "Total",
  "pan.cur.coldStart": "Cold-start",
  "pan.cur.empty": "No carriers on the panel yet.",
  "pan.cur.note": "Share of carriers with a CURATED score; the rest run on a cold-start seed.",
  // (2) Config governance
  "pan.cfg.title": "Config governance",
  "pan.cfg.pending": "Pending four-eyes approvals",
  "pan.cfg.active": "Active version per namespace",
  "pan.cfg.guardrail": "guardrail",
  "pan.cfg.activeEmpty": "No active version yet.",
  "pan.cfg.recent": "Recent config changes",
  "pan.cfg.colNamespace": "Namespace",
  "pan.cfg.colVersion": "Version",
  "pan.cfg.colStatus": "Status",
  "pan.cfg.colGovernance": "Governance",
  "pan.cfg.colReason": "Reason",
  "pan.cfg.colAsOf": "As of",
  "pan.cfg.empty": "No recorded config changes.",
  // (3) Customer #1 funnel
  "pan.fun.title": "Customer #1 funnel",
  "pan.fun.desc": "Acquisition funnel — realized counts (no forecast).",
  "pan.fun.leads": "Leads",
  "pan.fun.recommendations": "Recommendations",
  "pan.fun.issued": "Policies",
  "pan.fun.l2r": "Lead → Recommendation",
  "pan.fun.r2p": "Recommendation → Policy",
  "pan.fun.l2p": "Lead → Policy",
  // (4) KVKK / compliance
  "pan.kvkk.title": "KVKK / compliance",
  "pan.kvkk.consentTrend": "Consent trend (grants / withdrawals)",
  "pan.kvkk.grants": "Grants",
  "pan.kvkk.withdrawals": "Withdrawals",
  "pan.kvkk.suppression": "Suppression total",
  "pan.kvkk.suppressionEmpty": "No suppressed items.",
  "pan.kvkk.dsar": "DSAR / erasure requests",
  "pan.kvkk.dsarEmpty": "No data-subject requests on record.",
  "pan.kvkk.dsarOpen": "open",
  "pan.kvkk.dsarFulfilled": "fulfilled",
  // (5) Operational health
  "pan.ops.title": "Operational health",
  "pan.ops.paidNotIssued": "Paid, not issued",
  "pan.ops.issuanceExceptions": "Issuance exceptions",
  "pan.ops.slaBreaches": "SLA breaches",
  "pan.ops.byType": "By type",
  "pan.ops.calm": "Nothing needs action.",
  // (6) Pilot scorecard (R1–R6)
  "pan.pilot.title": "Pilot scorecard (R1–R6)",
  "pan.pilot.r1": "Channel conversion",
  "pan.pilot.r2": "Motor → Health",
  "pan.pilot.r3": "Household depth (median)",
  "pan.pilot.r4": "Retention rate",
  "pan.pilot.r5": "Commission received",
  "pan.pilot.r6": "Price integrity",
  "pan.pilot.cacPending": "CAC (channel spend) is the external Finance feed — pending.",
  "pan.pilot.costPending": "Advisor cost is the external Finance feed — pending.",

  // 05 — Carrier Quality Scorecard (founder layout chrome)
  "sc.breadcrumbRoot": "Carrier Quality",
  "sc.scoreTitle": "Overall quality score",
  "sc.scoreOutOf": "/ 100",
  "sc.scoreNoMetrics": "No measurable metric in this snapshot — no score was produced.",
  "sc.scoreBasis": "Metrics used",
  "sc.scoreConfigVersion": "Weights version",
  "sc.scorePartial":
    "Partial score: some model metrics are missing; weights were renormalised over the metrics present.",
  "sc.draftEditing": "Draft editing",
  "sc.metricsTitle": "Quality metrics",
  "sc.metricsWeightNote":
    "Metric weights come from the governed CARRIER_QUALITY config (versioned, effective-dated).",
  "sc.metricColdStart": "Not enough data for this carrier yet",
  "sc.metricColdStartBand":
    "Cold-start — this metric is excluded from the overall score until enough observations accrue.",
  "sc.historyTitle": "Version history",
  "sc.historyAppendOnly": "Append-only",
  "sc.historyCurrent": "Current (latest as_of)",
  "sc.historyNone": "No snapshot yet (cold-start).",
  "sc.auditTitle": "Audit info",
  "sc.auditSource": "Source",
  "sc.auditAsOf": "As of (as_of)",
  "sc.auditRecorded": "Recorded at",
  "sc.auditGovernNote":
    "Governed: every write is recorded in the audit trail and is append-only — the latest as_of wins, history is preserved (reconstructability).",
  "sc.auditFourEyesBackendFirst":
    "Separate-approver four-eyes (proposer ≠ approver) publication is backend-first for this resource: the quality endpoint is audited + append-only catalog:write, not approval-gated.",
  "sc.saveUnsaved": "You have unsaved changes",
  "sc.saveGovernNote":
    "Audited + append-only: a write is a new dated snapshot; the latest as_of wins — never overwritten.",
  "sc.saveDiscard": "Discard",

  // Customers — customer (party) management: list/search, detail + edit, password reset
  "nav.customers": "Customers",
  "cust.heading": "Customers",
  "cust.sub":
    "Search customers, view and update their details. Sensitive data is shown masked only.",
  "cust.list.title": "Customer list",
  "cust.loading": "Loading customers…",
  "cust.error": "Failed to load customers.",
  "cust.empty.list": "No customers yet.",
  "cust.empty.search": "No customers match your search.",
  "cust.search.by": "Search by",
  "cust.search.byName": "Name",
  "cust.search.byPhone": "Phone",
  "cust.search.term": "Search",
  "cust.search.namePlaceholder": "First or last name",
  "cust.search.submit": "Search",
  "cust.search.clear": "Clear",
  "cust.col.name": "Name",
  "cust.col.phone": "Phone",
  "cust.col.email": "Email",
  "cust.open": "View",
  "cust.more": "Load more",
  "cust.detail.loading": "Loading customer detail…",
  "cust.detail.error": "Failed to load customer detail.",
  "cust.account.yes": "Account: Yes",
  "cust.account.no": "Account: No",
  "cust.field.firstName": "First name",
  "cust.field.lastName": "Last name",
  "cust.field.email": "Email",
  "cust.field.phone": "Phone",
  "cust.field.phoneNote": "Phone can't be changed here — a change requires re-verification.",
  "cust.field.tckn": "TCKN (masked)",
  "cust.field.tcknNote": "Shown masked only; the full TCKN is a separate, audited action.",
  "cust.field.householdId": "Household",
  "cust.edit": "Edit",
  "cust.save": "Save",
  "cust.cancel": "Cancel",
  "cust.save.success": "Customer details updated.",
  "cust.toast.dismiss": "Dismiss",
  "cust.readOnly": "Read-only — you lack the edit grant (party:write).",
  "cust.reset.title": "Password reset",
  "cust.reset.note":
    "Generates a one-time temporary password for the customer's account; they set a new one at next login.",
  "cust.reset.action": "Reset password",
  "cust.reset.confirmTitle": "Reset the password?",
  "cust.reset.confirmBody":
    "A one-time temporary password will be created for this customer's account. This action may require step-up authentication.",
  "cust.reset.stepUp":
    "This action requires step-up authentication — verification was not completed.",
  "cust.reset.revealTitle": "Temporary password",
  "cust.reset.revealBody":
    "Convey this password to the customer once, over a secure channel (phone). It won't be shown again after this dialog closes.",
  "cust.reset.copy": "Copy",
  "cust.reset.copied": "Copied",
  "cust.reset.done": "Conveyed, close",

  // Team — IAM staff provisioning (create a new advisor / manager / admin)
  "nav.iam": "Team",
  "iam.heading": "Team",
  "iam.sub":
    "Create a new staff user (advisor, manager, admin). A one-time temporary password is generated for them.",
  "iam.create.title": "Create a new user",
  "iam.field.displayName": "Full name",
  "iam.field.displayNamePlaceholder": "e.g. Ayşe Yılmaz",
  "iam.field.email": "Email",
  "iam.field.role": "Role",
  "iam.create.submit": "Create user",
  "iam.role.SUPER_ADMIN": "Super Admin",
  "iam.role.ADMIN": "Admin",
  "iam.role.COMPLIANCE": "Compliance",
  "iam.role.OPS": "Operations",
  "iam.role.MANAGER": "Manager",
  "iam.role.ADVISOR": "Advisor",
  "iam.role.CLAIMS_COORDINATOR": "Claims Coordinator",
  "iam.role.FINANCE": "Finance",
  "iam.role.CONFIG_ADMIN": "Config Admin",
  "iam.role.ANALYTICS": "Analytics",
  "iam.role.elevatedHidden": "Admin / Super Admin roles can only be created by a super admin.",
  "iam.created.title": "User created",
  "iam.reveal.title": "Temporary password",
  "iam.reveal.note":
    "This password is shown only once — convey it to the user over a secure channel. They will set their own password at first login.",
  "iam.reveal.copy": "Copy",
  "iam.reveal.copied": "Copied",
  "iam.reveal.done": "Conveyed, close",
  "iam.error.dupEmail": "This email is already registered.",
  "iam.error.forbidden": "You are not allowed to create this role.",
  "iam.error.validation": "Please check the fields.",
  "iam.error.unavailable": "Staff provisioning is not configured right now.",
  "iam.error.noPermission": "You are not allowed to perform this action.",
  "iam.error.notFound": "Staff member not found.",
  "iam.error.conflict": "The action could not be completed, please try again.",
  "iam.error.generic": "The action could not be completed.",
  "iam.list.title": "Team list",
  "iam.list.loading": "Loading team…",
  "iam.list.error": "Failed to load the team.",
  "iam.list.empty": "No staff yet.",
  "iam.list.more": "Load more",
  "iam.col.name": "Full name",
  "iam.col.email": "Email",
  "iam.col.role": "Role",
  "iam.col.status": "Status",
  "iam.status.active": "Active",
  "iam.status.passive": "Inactive",
  "iam.manage": "Manage",
  "iam.manage.elevatedLocked": "Only a super admin can manage admin accounts.",
  "iam.edit": "Edit",
  "iam.edit.save": "Save",
  "iam.edit.cancel": "Cancel",
  "iam.edit.success": "Staff member updated.",
  "iam.status.title": "Login status",
  "iam.status.enable": "Enable",
  "iam.status.disable": "Disable",
  "iam.status.selfNote": "You cannot disable your own account.",
  "iam.status.success": "Status updated.",
  "iam.reset.title": "Reset password",
  "iam.reset.note":
    "Generates a temporary password; the staff member sets their own at first login.",
  "iam.reset.action": "Reset password",
  "iam.reset.confirmTitle": "Reset the password?",
  "iam.reset.confirmBody":
    "A temporary password will be generated and the staff member will be asked to change it at first login.",
  "iam.toast.dismiss": "Dismiss",

  // KVKK — Data-subject requests (DSAR register)
  "nav.dsar": "KVKK requests",
  "dsar.heading": "KVKK — Data-subject requests",
  "dsar.sub":
    "Log, list and advance data-subject requests (KVKK art. 11). Statutory response window: 30 days from receipt.",
  "dsar.readOnly": "You have read-only access to this section.",
  "dsar.create.title": "Log a new request",
  "dsar.create.submit": "Log request",
  "dsar.create.dueInfo": "Statutory window: received + 30 days (computed automatically).",
  "dsar.field.subject": "Data subject (Party ID)",
  "dsar.field.subjectHint": "The subject's party id (UUID). You can also search below to pick one.",
  "dsar.field.subjectPicked": "Selected: ",
  "dsar.field.type": "Request type",
  "dsar.field.channel": "Intake channel",
  "dsar.field.note": "Note (optional)",
  "dsar.field.notePlaceholder": "Short description",
  "dsar.field.fulfilled": "Fulfilled",
  "dsar.type.ACCESS": "Access",
  "dsar.type.ERASURE": "Erasure",
  "dsar.type.RECTIFICATION": "Rectification",
  "dsar.type.OBJECTION": "Objection",
  "dsar.type.PORTABILITY": "Portability",
  "dsar.channel.EMAIL": "Email",
  "dsar.channel.PHONE": "Phone",
  "dsar.channel.POST": "Post",
  "dsar.channel.IN_PERSON": "In person",
  "dsar.channel.WEB": "Web",
  "dsar.status.RECEIVED": "Received",
  "dsar.status.IN_PROGRESS": "In progress",
  "dsar.status.FULFILLED": "Fulfilled",
  "dsar.status.REJECTED": "Rejected",
  "dsar.overdue": "Overdue",
  "dsar.erasure.note":
    "Erasure requests cannot be marked Fulfilled by hand. Open the record and use “Execute erasure” to actually run the crypto-shred (ADR 0002); it requires a second approver and recent strong authentication.",
  "dsar.erasure.shred":
    "This is an erasure request. Fulfilled is reached only when the crypto-shred actually runs — the “Execute erasure” step below is the only path.",
  "dsar.erasure.title": "Execute erasure (crypto-shred)",
  "dsar.erasure.explain":
    "This action is IRREVERSIBLE. The subject's encryption keys are destroyed; keys for commercial records still inside their retention window are locked instead (RESTRICTED). The request moves to Fulfilled and the erasure reference is recorded.",
  "dsar.erasure.requestApproval": "Request second approval",
  "dsar.erasure.awaiting":
    "Waiting for a second person to approve. You cannot approve your own request.",
  "dsar.erasure.execute": "Execute erasure",
  "dsar.erasure.confirm": "This person's data will be irreversibly erased. Type ERASE to continue.",
  "dsar.erasure.confirmWord": "ERASE",
  "dsar.erasure.confirmLabel": "Confirmation",
  "dsar.erasure.done": "Erasure executed.",
  "dsar.erasure.receipt": "Erasure reference",
  "dsar.erasure.shredded": "Keys destroyed",
  "dsar.erasure.restricted": "Locked (still in retention)",
  "dsar.erasure.skipped": "Already inactive",
  "dsar.erasure.noApprover":
    "This action needs a second approver (dsr.erase:approve). A single operator cannot execute an erasure — deliberate, for an irreversible action.",
  "dsar.error.fourEyes": "The second-person approval is invalid or spent. Request approval again.",
  "dsar.error.stepUp": "This action requires recent strong authentication. Please sign in again.",
  "dsar.picker.by": "Search person",
  "dsar.picker.byName": "Name",
  "dsar.picker.byPhone": "Phone",
  "dsar.picker.term": "Search",
  "dsar.picker.namePlaceholder": "First or last name",
  "dsar.picker.search": "Search",
  "dsar.picker.pick": "Select",
  "dsar.picker.empty": "No matching person found.",
  "dsar.filter.status": "Status",
  "dsar.filter.type": "Type",
  "dsar.filter.any": "All",
  "dsar.list.title": "Request list",
  "dsar.list.loading": "Loading requests…",
  "dsar.list.error": "Could not load requests.",
  "dsar.list.empty": "No requests on record.",
  "dsar.list.more": "Load more",
  "dsar.col.subject": "Data subject",
  "dsar.subject.unresolved": "Subject name could not be resolved; showing the party id (UUID).",
  "dsar.col.type": "Type",
  "dsar.col.status": "Status",
  "dsar.col.received": "Received",
  "dsar.col.due": "Due",
  "dsar.manage": "Manage",
  "dsar.transition.title": "Advance status",
  "dsar.transition.terminal": "This request is closed; no further action is possible.",
  "dsar.transition.success": "Status updated.",
  "dsar.error.forbidden": "You are not authorized for this action.",
  "dsar.error.notFound": "Request not found.",
  "dsar.error.conflict": "That status transition is not allowed.",
  "dsar.error.validation": "Please check the fields.",
  "dsar.error.generic": "The action could not be completed.",
  "dsar.toast.dismiss": "Dismiss",
};

// The merged dictionary the admin I18nProvider feeds the foundation machinery:
// base chrome strings + the admin surface strings (the admin's app.title wins).
export const dictionaries = {
  tr: { ...baseTr, ...tr },
  en: { ...baseEn, ...en },
} as const;
